import {
  CampaignCreatePageKey,
  CampaignListPageKey,
  CampaignListTableKey,
  CampaignReviewPageKey
} from '../../TModules';

export const translations = {
  [CampaignListPageKey]: {
    Title: 'Campaigns',
    Label: 'Create New'
  },

  [CampaignListTableKey]: {
    All: 'All',
    Draft: 'Draft',
    Pending: 'Pending',
    Scheduled: 'Scheduled',
    Active: 'Active',
    Ended: 'Ended',
    Inactive: 'Inactive',
    SearchPlaceholder: 'Search campaign by name or id or internal notes',
    FilterBy: 'Filter by',

    // Game Types
    TapWin: 'Tap & win',
    CollectWin: 'Collect & win',
    ShakeTheTree: 'Shake The Tree',
    HitThePinata: 'Hit The Pinata',
    SpinTheWheel: 'Spin The Wheel',
    Plinko: 'Plinko',
    MysteryBox: 'Mystery box',
    ScratchCard: 'Scratch Card',
    BubblePop: 'Bubble Pop',

    OnDeactivateErrorMessage: 'Error deactivating campaign',
    OnApproveErrorMessage: 'Error approving campaign',
    OnMoveRowErrorMessage: 'Error sorting the campaign.',

    Approve: 'Approve',
    Review: 'Review',
    Edit: 'Edit',
    Activate: 'Activate',
    Deactivate: 'Deactivate',
    Duplicate: 'Duplicate',
    UploadTries: 'Upload tries',
    MoveToTop: 'Move to top',
    ApproveCampaign: 'Approve campaign',

    Name: 'Name',
    Type: 'Type',
    Status: 'Status',
    StartDate: 'Start date',
    EndDate: 'End date',
    Request: 'Request',
    Comments: 'Comments',
    Actions: 'Actions',
    AllGames: 'All games',
    ApproveRequests: 'Approve requests',
    CampaignTypeNotAllowedForApproval:
      'This campaign type is not enabled. Please contact Perx for further assistance.',
    InternalNotes: 'Internal Notes',
    ApproveMultipleMessageModal: {
      MultipleApproveRequestSuccessMessage: 'Requests have been approved',
      SuccessMessage: 'Campaigns approved',
      ErrorMessage: 'Error approving campaigns.',
      Title: 'Approve multiple requests?',
      OkText: 'Approve selected',
      CancelText: 'Cancel',
      DescriptionLineOne: 'Are you sure you want to approve all the selected requests?',
      DescriptionLineTwo:
        'Please verify the details before approving as this action cannot be undone.',
      ErrorApprovingRewards: 'Error approving rewards.'
    },

    ApproveMessageModal: {
      SuccessMessage: 'Request has been approved',
      FailureMessage: 'Error approving campaign.',
      Title: 'Approve campaign?',
      OkText: 'Approve',
      DescriptionLineOne: 'Are you sure you want to approve this campaign?',
      DescriptionLineTwo: 'This action cannot be undone.'
    },

    CampaignType: {
      AllCampaigns: 'All campaigns',
      InstantReward: 'Instant reward',
      Stamp: 'Stamp',
      Referral: 'Referral',
      Game: 'Game',
      Reward: 'Reward',
      Quiz: 'Quiz',
      Survey: 'Survey',
      Quest: 'Quest',
      Progress: 'Progress',
      Raffle: 'Raffle',
      MultipleRuleCampaign: 'Multiple rule campaign'
    }
  },

  [CampaignCreatePageKey]: {
    CreatingACampaign: 'Creating a Campaign',
    CampaignCreated: 'Campaign created',
    CampaignSubmittedForApproval: 'Campaign is submitted for approval',
    FailedToCreateCampaign: 'Failed to Create Campaign',
    DeactivatingCampaign: 'Deactivating Campaign...',
    CampaignDeactivationRequestSubmittedForApproval:
      'Campaign Deactivation Request Submitted For Approval!',
    DeactivatingSuccess: 'Deactivating Success...',
    FailedToDeactivate: 'Failed to Deactivate!',

    ActivatingCampaign: 'Activating Campaign...',
    CampaignActivationRequestSubmittedForApproval:
      'Campaign Activation Request Submitted For Approval!',
    ActivatingSuccess: 'Activating Success...',
    FailedToActivate: 'Failed to Activate!',
    UpdatingCampaign: 'Updating campaign',
    CampaignUpdateRequestSubmittedForApproval: 'Campaign is submitted for approval!',
    FailedToUpdate: 'Error updating campaign!',

    FailedToLoadData: 'Failed to Load Data!',
    FailedToOrderCampaign: 'Failed to Order Campaign!',

    DuplicatingCampaign: 'Duplicating campaign...',
    OnSubmitErrorMessage: 'No changes detected',

    RequiredErrorMessage: 'Campaign name is required',
    UploadedImagesShouldBeSetAsASection: 'Uploaded images should be set as a section',
    PromoteUntilMustBeAfterStartDate: 'Promote until date must be after start date',
    PromoteUntilMustBeBeforeEndDate: 'Promote until date must be before end date',
    PromoteUntilMustBeBetweenStartAndEndDate:
      'Promote until date must be between start and end date',
    PleaseSelectAnOwner: 'Please select an owner',
    PleaseAddAtLeast2Outcomes: 'Please add at least 2 outcomes',
    PrizeSetMustIncludeAtLeastOnePrizeForSlotNumber:
      'Prize set must include at least one prize for slot number {{position}}',
    PleaseAddAPrizeTitleForSlotNumber: 'Please add a prize title for slot number {{position}}',
    PleaseAddAtLeast2OutcomesForSlotNumber:
      'Please add at least 2 outcomes for slot number {{position}}',
    PrizeSetMustIncludeAtLeastOnePrize: 'Prize set must include at least one prize',
    RandomOutcomeSetMustIncludeAtLeastOneOutcome:
      'Random outcome set {{index}} must include at least one outcome',
    RandomOutcomeSetMustIncludeAtLeastTwoOutcomes:
      'Random outcome set {{index}} must include at least 2 outcomes',
    TotalProbabilityOfRandomOutcomeSet:
      'Total probability of Random outcome set {{index}} should be 100%',
    HeadlineHasToBeSet: 'Headline has to be set',
    SubHeadlineHasToBeSet: 'Subheadline has to be set',
    RewardMustBePlacedOnAtLeastOneWedge: 'Reward must be placed on at least one wedge',
    AtLeast1WedgeMustRemainEmptyIfNoOutcomeIsSelected:
      'At least 1 wedge must remain empty if "No Outcome" is selected',
    EachOutcomeMustHaveADuplicateScore:
      'Each outcome must have a unique score. Duplicates found: {{duplicateList}}',
    ScoreMustBeGraterThanZero: 'Score must be grater than 0.',
    AtLeastOneBubbleMustBeConfigured: 'At least one bubble must be configured',
    ColorHasToBeSet: 'Color has to be set',
    PointHasToBeSet: 'Point has to be set',
    SVGCodeIsRequired: 'SVG code is required when custom image is selected.',
    TargetTypeMustBeSelected: 'Target type must be selected.',
    BubbleSpawnRateMustBeSelected: 'Bubble spawn rate must be selected.',
    MaxBubblesMustBePositive: 'Max bubbles must be a positive number.',
    SpawnIntervalMustBeAtLeast100ms: 'Spawn interval must be at least 100 milliseconds.',
    BubbleLifetimeMustBeAtLeast500ms: 'Bubble lifetime must be at least 500 milliseconds.',
    BubblesPerSpawnMustBePositive: 'Bubbles per spawn must be a positive number.',
    BubblesPerSpawnMustNotExceedMaxBubbles: 'Bubbles per spawn must not exceed max bubbles.',
    GameDurationMinimum10Seconds: 'Game duration must be at least 10 seconds.',
    MaximumOf5BubblesCanBeMarkedAsBonus: 'A maximum of 5 bubbles can be marked as bonus.',
    BonusImageOccurrenceMustBeBetween1And6: 'Bonus image occurrence must be between 1 and 6.',
    YouNeedToAddAtLeastOneQuestionToThe:
      'You need to add at least one question to the {{campaignType}}.',
    EnglishTextForTheQuestionIsRequired:
      'English text for the question #{{questionNumber}} is required',
    EnglishTextForTheChoiceIsRequired:
      'English text for the choice #{{choiceNumber}} of the question #{{questionNumber}} is required',
    YouNeedToAddAtLeastOneTask: 'You need to add at least one task',
    YouNeedToSpecifyARuleForTheTask: 'You need to specify a rule for the task #{{taskNumber}}',
    CampaignDurationIsRequired: 'Campaign duration is required',
    CampaignDurationMustBeGreaterThanZero: 'Campaign duration must be greater than 0',
    BodyHasToBeSetForQuestDisplaySetup: 'Body has to be set for quest display set-up',
    YouNeedToSpecifyTheTeamSize: 'You need to specify the team size',
    TeamSizeMustBePositive: 'Team size must be positive',
    EnglishHeadlineCannotBeEmpty: 'English headline cannot be empty',
    LevelTabNameCannotBeEmpty: "'Level Tab' name cannot be empty",
    CampaignPointsShortFormCannotBeEmpty: "'Campaign-points short form' cannot be empty",
    YouNeedToSpecifyACampaignPointsForTheLevel:
      'You need to specify a campaign points for the Level #{{levelNumber}}',
    YouNeedToSpecifyAnIssuePrizeDescriptionForTheLevel:
      'You need to specify an "Issue prize" Description for the Level #{{levelNumber}}',
    LevelPointsMustBeMoreThanLevelPoints:
      'Level {{levelNumber}} points must be more than level {{errorIndex}} points!',
    YouNeedToAddAtLeast2OutcomesForTheLevel:
      'You need to add at least 2 outcomes for the Level #{{levelNumber}}',
    PrizeSetRequiresAPrizeTitleForTheLevel:
      'Prize set requires a prize title for the Level #{{levelNumber}}',
    YouNeedToAddAtLeastOneOutcomeForTheRandomizedOutcomeSet:
      'You need to add at least one outcome for the Randomized Outcome Set {{randomOutcomeIndex}} in Level #{{levelNumber}}',
    TheProbabilitiesOfTheOutcomesInRandomizedOutcomeSet:
      'The probabilities of the outcomes in Randomized Outcome Set {{randomOutcomeIndex}} of Level #{{levelNumber}} must sum to 100%',
    EachOutcomeProbabilityInRandomizedOutcomeSetMustBeGreaterThanZero:
      "Each outcome's probability in Randomized Outcome Set {{randomOutcomeIndex}} of Level #{{levelNumber}} must be greater than 0%",
    HowToParticipateTabNameCannotBeEmpty: "'How To Participate' tab name cannot be empty",
    HowToParticipateBodyTextCannotBeEmpty: "'How To Participate' body text cannot be empty",
    NumbersHaveToBeLessThan: 'Numbers have to be less than {{maxValue}}!',
    OperatingClosesTimeShouldBeGreaterThanOperatingOpensTime:
      'Operating closes time should be greater than operating opens time',
    OperatingOpensTimeShouldBeEarlierThanOperatingClosesTime:
      'Operating opens time should be earlier than operating closes time',
    DaysCannotBeEmptyPleaseSelectValidDays: 'Days cannot be empty. Please select valid days',
    TimesCannotBeEmptyPleaseSelectValidTimes: 'Times cannot be empty. Please select valid times',
    ProbabilityMustAlwaysAddUpTo100: 'Probability must always add up to 100%',
    ProbabilityShouldBeGreaterThan0: 'Probability should be greater than 0%',
    OutcomesCannotBeEmpty: 'Outcomes cannot be empty.',
    EndDateCannotBeEmpty: 'End Date cannot be empty.',
    AddAtLeastOneRule: 'Add at least one rule',
    AddAtLeastOnePrizeSet: 'Add at least one prize set',
    AddAtLeastOneOutcomeToThePrizeSet: 'Add at least one outcome to the prize set',
    PleaseUploadTheFile: 'Please upload the file',
    CampaignRequestUpdated: 'Campaign request updated',
    CampaignIsSubmittedForApproval: 'Campaign is submitted for approval',
    CampaignUpdated: 'Campaign updated',
    LimitTo: 'Limit to',
    SelectTaskTypeIsRequired: 'Select task type is required',
    StreakModeIsRequired: 'Streak mode is required',
    AmountSpendIsRequired: 'Amount Spend is required',
    AmountSpendMustBeGreaterThanZero: 'Amount Spend must be greater than zero',
    StreakTargetIsRequired: 'Streak Target is required',
    StreakTargetCriteriaIsRequired: 'Streak Target Criteria is required',
    StreakDurationIsRequired: 'Streak duration is required',
    MilestonesAndPrizesAreRequired: 'Milestones and Prizes are required',
    AtLeastOneOutcomeIsRequiredForMilestonesAndPrizes:
      'At least one outcome is required for Milestones and Prizes',
    AtLeastOneConditionIsRequired: 'At least one condition is required',
    InvalidCondition: 'Invalid condition',
    SelectTriggerFieldIsRequired: 'Select Trigger field is required',
    OperatorFieldIsRequired: 'Operator field is required',
    ValueIsRequired: 'Value is required',

    Steps: {
      Back: 'Back',
      Cancel: 'Cancel',
      Next: 'Next',
      SaveAsDraft: 'Save as draft',
      Publish: 'Publish',
      Save: 'Save',
      Deactivate: 'Deactivate',
      Schedule: 'Schedule',
      Info: 'Info',
      SelectAudience: 'Select Audience',
      Mechanics: 'Mechanics',
      StreakMode: 'Streak mode',
      TaskType: 'Task Type',
      StreakTargetAndPrizes: 'Streak Target and Prizes',
      Review: 'Review',
      DetailedTitle: {
        Info: 'Campaign Info',
        SelectAudience: 'Select Audience',
        Mechanics: 'Mechanics',
        Review: 'Review'
      },
      ViewInsights: 'View Insights',
      Edit: 'Edit',
      Loading: 'Loading'
    },

    CampaignInfo: {
      Title: 'Campaign details',
      Form: {
        Name: 'Name',
        NamePlaceholder: 'Please input your campaign name',
        ContentSuggestions: 'Content suggestions',
        ShowChatGPTForm: {
          TooltipTitle:
            'Token limits renew daily. Become a Perx exclusive member for unlimited tokens',
          TokensLeft: 'tokens left'
        },
        Description: 'Description',
        TermsAndConditions: 'Terms and conditions',
        RiskDisclaimer: 'Risk disclaimer',
        InternalNotesNotVisibleToCustomers: 'Internal notes (not visible to customers)',
        InternalNotesNotVisibleToCustomersPlaceholder:
          'Enter optional notes for internal use only. This text is not visible to customers.',
        MaxCharacters: 'Max {{count}} chars.',
        CampaignDuration: 'Campaign duration',
        StartDate: 'Start date',
        EndDate: 'End date',
        EarlyDisplayCampaign: 'Start displaying the campaign',
        DaysBeforeStartDate: 'days before the start date',
        DaysBeforeTheStartDate: 'days before the start date',
        CampaignDoesNotEnd: 'Campaign does not end',
        ShouldHideDurationEndDateAlertMessage: 'Raffles campaigns require an end date',
        PromoteCampaignAsNew: "Promote this campaign as 'NEW' until",
        EndDateAlertMessage: 'End Date must be on or after the Start Date',

        Reset: 'Reset',
        OCBCDemo: {
          Never: 'Never',
          Weekly: 'Weekly',
          Monthly: 'Monthly',
          Yearly: 'Yearly'
        },

        ActiveAt: 'Active at',
        ActiveAtMessage: 'Campaign does not activate before start date',

        Tags: 'Tags',
        Categories: 'Categories',
        Labels: 'Labels',
        Catalogues: 'Catalogues',
        Owner: 'Owner',
        PleaseSelectAnOwner: 'Please select an owner',

        UploadPhoto: 'Upload photo',
        UploadMultipleImages: 'Upload multiple images',
        Merchant: 'Merchant',
        MerchantSelectPlaceholder: 'Please select a merchant',
        Locations: 'Locations',
        LocationsSelectPlaceholder: 'Please select locations',
        CustomFields: 'Custom fields',
        CustomField: 'Custom field',
        CustomFieldNamePlaceholder: 'Type in field name',
        CustomFieldValuePlaceholder: 'Type in field value',
        AddCustomField: 'Add custom field'
      },

      TagSelect: 'Please select your tags',
      CategorySelect: 'Please select your categories',
      LabelSelect: 'Please select your labels',
      CatalogueSelect: 'Please select your catalogues'
    },

    ButtonWithImageUpload: {
      Cancel: 'Cancel',
      InsertPhoto: 'Insert photo',
      UploadFile: 'Upload a file',
      ChooseFile: 'Choose file',
      ChooseAFile: 'Choose a file',
      SelectPngSvgJpegGif: 'Select PNG, SVG, JPEG or GIF'
    },

    CampaignSelectAudience: {
      SelectAudience: 'Select an Audience',
      DefaultAudience: 'Create a single-use audience for this campaign',
      ExistingAudience: 'Select an existing audience',
      AudienceSetup: 'Audience setup',
      SelectAudienceV4Placeholder: 'Select audience',
      SelectFilters: 'Select filters',
      SelectedFilters: 'Selected filters',

      AudienceListSetup: {
        Include: 'Include',
        Exclude: 'Exclude',
        AudienceExistsMessage: `Can't {{audienceIncludeExclude}} audience that's already set for {{audienceIncludeExcludeNoun}}`,
        PickAudienceList: 'Pick an audience list',

        Includes: 'Includes',
        Excludes: 'Excludes',
        AudienceWarningMessage:
          'The uploaded audience file will only be processed after it has been approved by a Bulk Actions Approver',
        SelectedFileForInclusion: 'Selected file for inclusion',
        AudienceNotInTheList: 'Audience not in the list',
        IncludeAudienceFilenamePlaceholder: 'Name the list of included audience',
        UploadNow: 'Upload now',
        UploadNewList: 'Upload new list',
        AcceptedFormat: 'Accepted Format: .xlsx/.csv files only.',
        DownloadSample: 'Download sample',
        UploadExclusion: 'Upload Exclusion',
        SelectedFileForExclusion: 'Selected file for exclusion',
        ExcludeAudienceFilenamePlaceholder: 'Name the list of excluded audience'
      },

      AudienceFilters: {
        Age: 'Age',
        BirthMonth: 'Birth Month',
        Gender: 'Gender',
        Location: 'Location',
        Loyalty: 'Loyalty',
        Personal: 'Personal',
        Custom: 'Custom',
        EmailTags: 'Email tags',
        Ethnicity: 'Ethnicity',
        SelectCustomerAttributeFilters: 'Select your customer-attribute filters:',
        NoFiltersSelected: 'No filters selected',
        And: 'and',
        Badge: 'Badge',
        Campaign: 'Campaign',
        Leaderboard: 'Leaderboard',
        LoyaltyPoints: 'Loyalty points',
        LoyaltyTier: 'Loyalty tier',
        MemberSince: 'Member since',
        Reward: 'Reward',
        PaymentBased: 'Payment based',
        Payment: 'Payment',
        SelectFilters: 'Select filters to auto-generate an audience list',
        City: 'City',
        States: 'States',

        OfferId: 'Offer ID',
        PrimaryClusterComb: 'Primary Cluster Comb',
        PrimaryClusterState: 'Primary Cluster State',
        Membership: 'Member Of',
        CurrentBirthday: 'Only During Day Of Birth',
        CurrentBirthMonth: 'Only During Month Of Birth',
        HasBirthday: 'On Birthday',
        UserType: 'User Type',
        AccountConfirmedAt: 'Signed up between',
        LoyaltyPointsBalance: 'Points balance',
        CampaignEnrolment: 'Campaign',
        LeaderboardPosition: 'Leaderboard position',
        UPI: 'UPI',
        ScanPay: 'Scan pay',
        BBPS: 'BBPS',
        KYC: 'KYC',
        CurrentAddress: 'Current address',
        PaymentStatus: 'Payment status',
        DaysPastDues: 'Days past dues',
        BNPLUnpaidEMIDate: 'BNPL Unpaid EMI Date',
        InstaloanUnpaidEMIDate: 'Instaloan Unpaid EMI Date',

        AgeFilter: {
          Title: 'Age',
          Includes: 'Includes',
          Excludes: 'excludes',
          SelectPlaceholder: 'Includes',
          From: 'ages from',
          FromPlaceholder: '18',
          To: 'to',
          ToPlaceholder: '35',
          AddRange: 'Add range',
          And: 'and',
          from: 'from'
        },
        BirthdayFilter: {
          Title: 'Birthday',
          SelectBirthMonth: 'Select birth month',
          BirthMonth: 'Birth month',
          CurrentBirthMonth: 'Current birth month',
          OnlyDuringMonthOfBirth: 'Only during month of birth',
          HasBirthday: 'Has birthday',
          OnBirthday: 'On birthday',
          Includes: 'Includes',
          Excludes: 'Excludes'
        },
        GenderFilter: {
          Title: 'Gender',
          SelectByGender: 'Select by Gender',
          Male: 'Male',
          Female: 'Female'
        },
        EthnicityFilter: {
          Title: 'Ethnicity',
          SelectEthnicity: 'Select Ethnicity',
          SelectEthnicityPlaceholder: 'Select ethnicity',
          Include: 'Include',
          Exclude: 'Exclude',
          Includes: 'Includes',
          Excludes: 'excludes'
        },
        LocationFilter: {
          Title: 'Location',
          SelectCity: 'Select City',
          Include: 'Include',
          Exclude: 'Exclude',
          SelectCityPlaceholder: 'Select cities',
          SelectState: 'Select State',
          SelectStatePlaceholder: 'Select state',
          Includes: 'Includes',
          Excludes: 'Excludes'
        },

        PersonalFilter: {
          Title: 'Personal',
          HubClub: 'Hub Club',
          Select: 'Select',
          Include: 'Include',
          Exclude: 'Exclude',
          AddCustomProperties: 'Add custom properties',
          EnterKeyNameAndValueDetails: 'Enter key name and value details',
          SelectRelation: 'Select relation',
          EnterNumber: 'Enter number',
          KeyValue: 'Key value',
          DatePlaceholder: 'DD-MM-YYYY',
          KeyNamePlaceholder: 'Key name',
          Is: 'Is',
          True: 'True',
          False: 'False',
          And: 'AND',
          Or: 'OR',
          CustomAttributeType: 'Custom attribute #{{index}}: type',
          CustomAttribute: 'Custom attribute #{{index}}: attribute',
          CustomAttributeOperator: 'Custom attribute #{{index}}: operator',
          CustomAttributeValue: 'Custom attribute #{{index}}: value'
        },

        LoyaltyFilter: {
          Title: 'Loyalty',
          SelectLoyaltyProgram: 'Select Loyalty Program',
          Include: 'Include',
          Exclude: 'Exclude',
          SelectProgram: 'Select program',
          Includes: 'Includes',
          Excludes: 'Excludes',
          UsersWithPointsBalance: 'Users with points balance',
          SelectLoyaltyProgramPlaceholder: 'Select loyalty program',
          From: 'From',
          To: 'To',
          PointsBalanceFrom: 'Points balance from',
          PointsBalanceTo: 'Points balance to'
        },

        EmailTagsFilter: {
          Includes: 'Includes',
          SelectEmailTags: 'Select email tags',
          Excludes: 'Excludes'
        }
      }
    },

    SocialMediaFields: {
      Title: 'Social media',
      OGTitle: 'Title',
      OGDescription: 'Description',
      OGImage: 'Image',
      OGImageAlt: 'Social media review',
      IOSAppLink: 'iOS app link',
      AndroidAppLink: 'Android app link',
      WebLink: 'Web link',
      EitherAnIOSOrAndroidOrWebLinkIsRequired: 'Either an iOS or Android or Web link is required',
      Allowed: 'Allowed: .jpg, .png, .svg',
      Browse: 'Browse',
      Recommended: 'Recommended: 720px by 120px',
      TitleIsRequired: 'Title is required.'
    },

    CampaignMechanics: {
      CampaignType: 'Campaign type',
      InstantReward: 'Instant reward',
      MultipleRuleCampaign: 'Multiple rule campaign',
      Reward: 'Reward',
      Progress: 'Progress',
      Raffle: 'Raffle',
      Stamp: 'Stamp',
      Game: 'Game',
      Quest: 'Quest',
      Referral: 'Referral',
      Survey: 'Survey',
      Quiz: 'Quiz',
      Streak: 'Streak',
      GiveRewardTitle: 'Instant issue all rewards',
      Yes: 'Yes',
      No: 'No',

      OutcomeType: 'Outcome Type',
      FixedPrize: 'Customers get a fixed prize',
      ChoosePrize: 'Customers choose their preferred prize',

      GameTry: 'Game try',
      AwardBadges: 'Award badges',
      AwardPoints: 'Award points',
      AddRewards: 'Add rewards',
      AddPrizeToSet: 'Add prize to set',
      IncludeNoPrizeAsOutcome: 'Include no prize as outcome',
      RandomOutcomeSet: 'Random Outcome Set {{index}}',
      PrizeSet: 'Prize Set {{index}}',

      LevelsAndPrizes: 'Levels & Prizes',
      LandingPage: 'Landing Page',
      ProgressMechanics: 'Progress mechanics',

      InstantRewardMechanics: 'Instant reward mechanics',
      ListCheckboxLabel: "Show campaign in user's campaign listing?",
      ListCheckboxSendPushNotificationLabel: 'Send push notification for every rule trigger?',
      MediaTagsToInclude: 'Media Tags To Include',
      SelectMediaTags: 'Select Media Tags',
      AddRule: 'Add rule',
      Name: 'Name',
      Action: 'Action',
      Edit: 'Edit',
      Remove: 'Remove',

      IssuanceLimits: 'Issuance limits',
      TotalNumberOfIssuePrizeEventsOnCampaignLevel:
        'Total number of issue-prize events (on campaign level)',
      TotalNumberOfIssuePrizeEventsPerUser: 'Total number of issue-prize events (per user)',
      IssuanceLimitsPerUser: 'Issuance limits (per user)',
      IssuanceLimitsPerUserPlaceholder: '∞',
      IssuePrizeEvents: 'issue-prize event(s)',
      RateLimitOnCampaignLevel: 'Rate limit (on campaign level)',
      IssuePrizeEventsForEvery: 'issue-prize event(s) for every',
      Day: 'day',
      RateLimitPerUser: 'Rate limit (per user)',
      LimitTo: 'Limit to',
      LeaveTheLimitFieldsBlankForUnlimitedIssuePrizeEvents:
        '^ Leave limit field blank for unlimited issue-prize events',
      SvgHarmfulTagsRemovedSuccessfully: 'SVG harmful tags removed successfully!',
      ImageHelpText: '1:1 aspect ratio recommended , 500kb max in jpg or png',
      Upload: 'Upload',

      PrizeEarnedPopUp: 'Prize earned pop up',
      AppearsUponCustomerSignInToMicrosite: 'Appears upon customer sign-in to microsite',
      Headline: 'Headline',
      PleaseInputYourHeadline: 'Please input your headline',
      SubHeadline: 'Sub-headline',
      PleaseInputYourSubHeadline: 'Please input your sub headline',
      Image: 'Image',
      ClaimPrizeButtonText: 'Claim-prize button text',
      PleaseInputClaimPrizeButtonText: 'Please input claim prize button text',
      AddTask: 'Add task',
      SomethingWentWrong: 'Something went wrong',
      MaxNumberReachedWarning: 'Limit of 10 tasks per quest reached',
      TaskIndex: 'Task {{index}}',

      WinProbability: 'Win Probability:',
      WinProbabilityPercent: 'Win Probability %',
      loyaltypoints: 'loyalty points',
      loyaltypoint: 'loyalty point',

      StampRuleTable: {
        ID: 'ID',
        Name: 'Name',
        RuleType: 'Rule type',
        NumberOfStamps: 'Number of stamps',
        Action: 'Action',
        Edit: 'Edit',
        Remove: 'Remove'
      },

      SelectOutcomes: 'Select outcomes',
      OnlyRewardsWithConfiguredTags:
        'Only rewards with configured tags can be selected when customers are choosing their prize.',
      ConfigureRaffleCodes: {
        Title: 'Configure raffle codes',
        SelectCodeType: 'Select code type',
        SystemGenerated: 'System generated',
        UserUpload: 'User upload',
        TicketCodePrefix: 'Ticket code prefix',
        LengthOfCode: 'Length of code',
        NumberOfTickets: 'Number of tickets',
        CodeFormat: 'Code format',
        TotalPermutations: 'Total permutations',
        SelectFile: 'Select file',
        UploadCodes: 'Upload codes',
        AcceptedFormats: 'Accepted formats: .txt, .xlsx or .csv files only.'
      },

      RaffleRules: {
        Title: 'Earn rules',
        AddRule: 'Add rule'
      },

      GrandPrizes: {
        Title: 'Grand prizes',
        LimitGrandPrizesToOnePerCustomerOnly: 'Limit Grand Prizes to One per Customer only',
        ThisSettingRequiresMultipleGrandPrizesToBeDefined:
          'This setting requires multiple grand prizes to be defined',
        AllocateRafflePrizesForIndividualPositionsOrARange:
          'Allocate raffle prizes for individual positions or a range . E.g. prize set 1 for 1st position holder and prize set 2 for 2nd to 5th position holders.',
        AddPrizeSet: 'Add prize set',
        Position: 'Position:',
        PrizeSetWithPositionStartsWith: 'Prize set {{index}}: position starts with',
        PrizeSetWithPosition: 'Prize set {{index}}: position',
        PrizeSet: 'Prize set {{index}}',
        ConvertPositionToRange: 'Convert position to range'
      },

      OutcomeSettings: {
        Title: 'Outcome settings - appears upon customer sign-in to microsite',
        RaffleTicketOutcome: 'Raffle ticket outcome',
        GrandPrizeOutcome: 'Grand prize outcome',
        RaffleTicket: 'Raffle ticket',
        GrandPrize: 'Grand prize',
        Headline: 'Headline',
        Subheadline: 'Subheadline',
        WinRewardGraphic: 'Win reward graphic',
        ClaimPrizeButtonText: 'Claim prize button text'
      },

      QuestMechanics: {
        Title: 'Quest mechanics',
        UserTriesValidity: 'User-tries validity',
        UserTriesValidityPlaceholder: '100',
        UserTriesValidityPeriodPlaceholder: 'days',
        Hours: 'hours',
        Days: 'days',
        Months: 'months',
        Years: 'years',
        TotalNumberofQuests: 'Total number of quests that can be started in a campaign',
        TotalNumberofQuestsPlaceholder: '∞',
        Quests: 'quests',
        TotalNumberofQuestsPerUser: 'Total number of quests that can be started by each user',
        TotalNumberofQuestsPerUserPlaceholder: '∞',
        LeaveTheLimitFieldsBlankForUnlimitedIssuances:
          '^ Leave limit field blank for unlimited issuances',
        QuestDisplaySetUp: 'Quest display Set-Up',
        Headline: 'Headline',
        SubHeadline: 'Sub-headline',
        BodyText: 'Body text',
        Image: 'Image',
        ImageHelpText: 'Min size 360(w) x 144(h) px in jpg or png',
        TasksDisplay: 'Tasks display',
        TaskIndex: 'Task {{index}}',
        TaskDoneBadge: 'Task-done badge',
        TaskDoneBadgeHelpText: 'w: 130px &times; h: 130px',
        TaskHeadline: 'Task headline',
        TaskSubHeadline: 'Task sub-headline',
        TaskIcon: 'Task icon',
        ButtonText: 'Button text',
        ButtonExternalLink: 'Button external link'
      },

      QuizQuestions: {
        Title: 'Questions',
        AddQuestion: 'Add question',
        Type: 'Type',
        TextQuestion: 'Text question',
        ImageQuestion: 'Image question',
        WrittenResponse: 'Written response',
        MultipleAnswers: 'Multiple answers',
        SingleAnswer: 'Single answer',
        Question: 'Question',
        Required: 'Required',
        Actions: 'Actions',
        Edit: 'Edit',
        Delete: 'Delete',

        EditQuestion: 'Edit question',
        UpdateQuestion: 'Update question',
        Cancel: 'Cancel',
        QuestionType: 'Question type',
        TextChoice: 'Text choice',
        ImageChoice: 'Image choice',
        CharactersLeft: 'characters left',
        Description: 'Description',
        ImageHelpText: 'w: 360px &times; h: 145px | Allowed: .jpg, .jpeg, .png, .svg',
        LabelForQuestionImage: 'Label for question image',
        RequiredToAnswer: 'Required to answer',
        RequiredToAnswerDescription:
          'Survey participants will be able to type their answer in a text area, as shown below:',
        InputFieldExample: 'Input field example',
        AllowSelectingMultipleAnswers: 'Allow selecting multiple answers',
        ChooseCorrectAnswer: 'Choose correct answer',
        IsSurveyChoice: 'Choice #{{index}}',
        AnswerChoice: 'Answer choice #{{index}}',
        Option: 'Option #{{index}}',
        EachQuestionRequiresAtLeastTwoAnswers: 'Each question requires at least two answers',
        AddAnother: 'Add another',
        Answer: 'answer',

        ShowOthers: 'Show “Other (please specify):”',
        Other: 'Other (please specify):',

        RequiredField: 'This is a required field!',
        YouNeedToTypeIn: 'You need to type in',
        AnAnswer: 'an answer',
        AQuestion: 'a question',
        OrUploadAnImage: 'or upload an image',
        YouNeedToSelectMoreThanOneCorrectAnswer: 'You need to select more than one correct answer',
        YouNeedToSelectAtLeastOneCorrectAnswer: 'You need to select at least one correct answer',
        PleaseTypeInYourAnswer: 'Please type in your answer',
        Recommended: 'Recommended: 720px by 120px | Allowed: .jpg, .png, .svg',
        Upload: 'Upload'
      },

      QuizTimer: {
        Title: 'Quiz timer',
        SetATimeLimitForEachQuestion: 'Set a time limit for each question',
        CountUp: 'Count up',
        CountDown: 'Count down',
        MaximumCount: 'Maximum count',
        MaximumCountPlaceholder: '∞',
        Seconds: 'Seconds'
      },

      QuizLimits: {
        Title: 'Quiz limits',
        SurveyLimits: 'Survey limits',
        QuizLimits: 'Quiz limits',
        AutoIssueMoves: 'Auto-Issue moves',
        TotalLimitsInTheCampaignIs: 'Total {{campaingType}} limits in the campaign is',
        InfiniteUses: 'NOTE: For infinite uses, leave the field blank.',
        IndividualUsersCanOnlyAttemptThisQuiz:
          'Individual users can only attempt this {{campaingType}}',
        InfiniteUsers: 'NOTE: For infinite users, leave the field blank.',
        TimesInTotal: 'times in total',
        TimesPer: 'times per',
        Day: 'day',
        Week: 'week',
        Month: 'month',
        Year: 'year',
        BlockUsersWhoAchieved100PercentCorrect:
          'Block users who achieved 100% correct answers from further attempts',
        BlockUsersWhoAchieved100PercentCorrectNote:
          'NOTE: Once a customer gets all answers in this quiz correct, they will not be able to answer the quiz again, regardless of any remaining game tries.'
      },
      QuizValidity: {
        Survey: 'Survey',
        Quiz: 'Quiz',
        Title: '{{campaingType}} validity',
        AfterIssueTheQuizWillExpireIn: 'After issue, the {{campaingType}} will expire in',
        QuizLimitPlaceholder: '100',
        Days: 'days',
        Months: 'months',
        Years: 'years'
      },
      QuizGraphicsSettings: {
        Title: 'Quiz properties',
        AppBackground: 'App background',
        FontColour: 'Font colour',
        CTAButtonBackgroundColour: 'CTA Button background colour',
        CTAButtonTextColour: 'CTA Button text colour',
        HelpText: 'w: 375px &times; h: 812px'
      },
      MicrositeGraphicsSettings: {
        Title: 'Microsite display properties',
        LandingScreen: 'Landing screen',
        OutcomeSettings: 'Outcome settings',
        Body: 'Body',
        InsertYouTubeEmbedURLHere: 'Insert youTube embed URL here',
        ButtonText: 'Button text',
        OutcomeSettingsScoreResult: 'Outcome Settings',
        SuccessfulOutcomeHeadline: 'Successful outcome headline',
        SuccessfulOutcomeBody: 'Successful outcome body',
        SuccessfulOutcomeImage: 'Successful outcome image',
        SuccessfulOutcomeImageHelpText: 'w: 400px &times; h: 400px',
        SuccessfulOutcomeButton: 'Successful outcome button',
        NoOutcomeTitle: 'No outcome title',
        NoOutcomeSubheadline: 'No outcome subheadline',
        NoOutcomeImage: 'No outcome image',
        NoOutcomeButton: 'No outcome button'
      },

      CampaignSelectModal: {
        Title: 'Select a campaign',
        OkText: 'Add campaign',
        CancelText: 'Cancel',
        SearchPlaceholder: 'Find a campaign by name, type or merchant',
        Name: 'Name',
        Status: 'Status',
        Tags: 'Tags',
        StartDate: 'Start Date',
        EndDate: 'End Date',
        Active: 'Active',
        Scheduled: 'Scheduled',
        ID: 'ID'
      }
    },

    Outcomes: {
      SelectOutcomes: 'Select outcomes',
      Name: 'Name',
      Action: 'Action',
      EditPoints: 'Edit points',
      Remove: 'Remove',
      EditReferralRule: 'Edit referral rule',
      MoveToTop: 'Move to top',
      MerchantName: 'Merchant name',
      SellingFrom: 'Selling from',
      SellingTo: 'Selling to',
      RewardBalance: 'Reward balance',
      PointsAwarded: 'Points awarded',
      ReferrerLimits: 'Referrer limits',
      ReferralsNeeded: 'Referrals needed',
      RefereeRewardLimit: 'Referee reward limit',
      AwardBadges: 'Award badges',
      AwardPoints: 'Award points',
      AddRewards: 'Add rewards'
    },

    CampaignRules: {
      AddRule: 'Add rule'
    },

    RuleGroup: {
      Mechanic: 'Mechanic'
    },

    RefferalSelectionModal: {
      Title: 'Edit referral rule',
      OnCancelError: 'Referral value it not number! Please check it!',
      OkButtonText: 'OK',
      RewardId: 'Reward id:',
      Referee: 'Referee',
      Referrer: 'Referrer',
      NoOfReferralsNeeded: 'No. of referrals needed',
      TotalRewardLimit: 'Total reward limit',
      RewardLimit: 'Reward limit',
      RewardBalance: 'Reward balance : ',
      CheckboxError: 'Referrer or Referee options are required',
      RewardIDTitle: 'Reward ID:',
      Points: 'Points',
      Of: ' of ',
      TotalOutcomeLimit: 'Total outcome limit',
      OutcomeLimit: 'Outcome limit',
      NumberError: 'This value must is be a number',
      RequiredError: 'This value is required'
    },

    CampaignReferralRewardPickerModal: {
      SearchRewards: 'Search rewards',
      Active: 'Active',
      Private: 'Private',
      Approved: 'Approved',
      System: 'System',
      SelectRewards: 'Select rewards',
      Back: 'Back',
      Next: 'Next',
      Done: 'Done',
      Name: 'Name',
      MerchantName: 'Merchant name',
      SellingFrom: 'Selling from',
      SellingTo: 'Selling to',
      RewardBalance: 'Reward balance',
      SetupReferralRule: 'Setup referral rule'
    },

    RewardPicker: {
      SelectRewards: 'Select rewards',
      OkButtonText: 'Add rewards',
      SearchRewards: 'Find a new reward by name, type or merchant',
      Active: 'Active',
      Private: 'Private',
      Approved: 'Approved',
      System: 'System',
      Ended: 'Ended',
      Inactive: 'Inactive',
      Draft: 'Draft',
      Name: 'Name',
      MerchantName: 'Merchant name',
      SellingFrom: 'Selling from',
      SellingTo: 'Selling to',
      RewardBalance: 'Reward balance'
    },

    CampaignReferralPointsModal: {
      PleaseSelectGLAccount: 'Please select a GL Account',
      PleaseSelectGLAccountTypeAndName: 'Please select a GL Account, Type and Name',
      PleaseSetNumberOfPointsToAward: 'Please set the number of points to award',
      SetPointsToAward: 'Set points to award',
      Next: 'Next',
      Done: 'Done',
      SelectLoyaltyProgram: 'Select loyalty program',
      HowManyPoints: 'How many points?',
      SelectGLAccount: 'Select GL Account',
      SelectGLAccountType: 'Select GL Account Type',
      SelectGLAccountName: 'Select GL Account Name',
      SelectGLAccountNamePlaceholder: 'Name',
      EnterPoints: 'Enter points',
      SetupReferralRule: 'Setup referral rule',
      AwardedPointsExpireIn: 'Awarded points expire in',
      NumberOfDaysPlaceholder: 'e.g., 7',
      Days: 'days'
    },

    GameTypesSelectModal: {
      Title: 'Select a game type',
      OkButtonText: 'Select game',
      CancelButtonText: 'Cancel',

      ShakeTheTree: {
        Title: 'Shake The Tree',
        InstructionsLineOne:
          'Engage customers with a challenge which requires them to shake the phone',
        InstructionsLineTwo: 'Game mechanics',
        InstructionsLineThree:
          '1. End-user gets a reward based on completing a required action in this case by shaking the tree',
        InstructionsLineFour:
          '2. Rewards are randomly issued out based on the probability set on the rewards',
        InstructionsLineFive: 'Ideal for',
        InstructionsLineSix: '1. Seasonal game'
      },
      HitThePinata: {
        Title: 'Hit The Pinata',
        InstructionsLineOne:
          'Engage customers with a challenge which requires them to hit the pinata',
        InstructionsLineTwo: 'Game mechanics',
        InstructionsLineThree:
          '1. End-user gets a reward based on completing a required action in this case by hitting the pinata',
        InstructionsLineFour:
          '2. Rewards are randomly issued out based on the probability set on the rewards',
        InstructionsLineFive: 'Ideal for',
        InstructionsLineSix: '1. Seasonal game'
      },
      ScratchCard: {
        Title: 'Scratch Card',
        InstructionsLineOne: 'Engage customers by getting them to scratch and win exciting prizes',
        InstructionsLineTwo: 'Game mechanics',
        InstructionsLineThree:
          '1. End-user gets a reward based on completing a required action in this case by scratching the card',
        InstructionsLineFour:
          '2. Rewards are randomly issued out based on the probability set on the rewards',
        InstructionsLineFive: 'Ideal for',
        InstructionsLineSix: '1. Seasonal game'
      },
      SpinTheWheel: {
        Title: 'Spin The Wheel',
        InstructionsLineOne:
          'Engage customers by getting them to Spin The Wheel and win exciting prizes',
        InstructionsLineTwo: 'Game mechanics',
        InstructionsLineThree:
          '1. End-user gets a reward based on completing a required action in this case by spinning the wheel',
        InstructionsLineFour:
          '2. Rewards are randomly issued out based on the probability set on the rewards',
        InstructionsLineFive: 'Ideal for',
        InstructionsLineSix: '1. Seasonal game'
      },
      Plinko: {
        Title: 'Plinko',
        InstructionsLineOne:
          'Engage customers by getting them to try their luck at getting the ball to the winning slot',
        InstructionsLineTwo: 'Game mechanics',
        InstructionsLineThree:
          '1. End-user gets a reward based on completing a required action in this case by dropping the ball',
        InstructionsLineFour:
          '2. Rewards are randomly issued out based on the probability set on the rewards',
        InstructionsLineFive: 'Ideal for',
        InstructionsLineSix: '1. Seasonal game'
      },
      BubblePop: {
        Title: 'Bubble Pop',
        InstructionsLineOne: 'Engage customers with a fun, fast-paced challenge that rewards real',
        InstructionsLineTwo: 'Game mechanics',
        InstructionsLineThree:
          '1. The end-user earns a score by tapping on colourful bubbles within 30 seconds',
        InstructionsLineFour:
          '2. Each bubble color is worth different positive or negative points — pop wisely',
        InstructionsLineFive:
          '3. Based on their final score, users are rewarded instantly with loyalty points, vouchers, game tries, or raffle tickets',
        InstructionsLineSix:
          '4. The higher the score, the better the reward — pure skill, no chance',
        InstructionsLineSeven: 'Ideal for',
        InstructionsLineEight: 'Campaigns where you want to reward engagement, not just luck'
      }
    },

    StreakTypesSelectModal: {
      SelectStreakCampaignType: 'Select Streak Campaign type',
      ContinuousLoop: 'Continuous Loop',
      Progressive: 'Progressive',
      CheckIn: 'Check In',
      MilestoneBased: 'Milestone Based',
      TransactionCount: 'Transaction Count',
      CumulativeSpend: 'Cumulative Spend',
      ContinuousLoopDescription:
        'Keep customers engaged by having them perform tasks repeatedly within a fixed time period, and then they get a reward each time they have',
      GameMechanicsTitle: 'Game mechanics',
      ContinuousLoopGameMechanicsLineOne:
        '1. The game is set to have a fixed period - either daily, weekly or monthly',
      ContinuousLoopGameMechanicsLineTwo:
        '2. Users are required to perform a specific task multiple times within the game period. Upon the user completing the tasks within the set duration, they get the reward, and the campaign automatically starts again at the next period.',
      IfCustomersMissAStreakTheyStartAgainAtTheNextStreakPeriod:
        '3. If customers miss a streak, they start again at the next streak period.',
      ContinuousLoopIdealForTitle: 'Ideal for',
      ContinuousLoopIdealForLineOne: '1. Daily Check in campaigns',

      MilestoneBasedDescription:
        'Set progressive goals for your customers to perform repeated tasks, with a prize issued for achieving each defined streak goal.',
      MilestoneBasedGameMechanicsTitle: 'Game mechanics',
      MilestoneBasedGameMechanicsLineOne:
        '1. The game is set to have a fixed interval - either daily, weekly or monthly.',
      MilestoneBasedGameMechanicsLineTwo:
        '2. The game has a defined task users must perform repeatedly - e.g.: Sign In, Perform a specific transaction, etc.',
      MilestoneBasedGameMechanicsLineThree:
        '3. Define milestones in terms of how many tasks must be performed, and how many continuous periods the tasks must be performed.',
      MilestoneBasedGameMechanicsLineFour:
        '4. Customers will be issued a prize each time they achieve the streak milestone. If customers miss a streak, they start again at the current milestone. Prizes are only awarded once per milestone.'
    },

    TeamsMechanics: {
      Title: 'Team mechanics',
      Description: 'Team mechanics settings cannot be updated once a campaign has been published.',
      ActivateTeamMechanics: 'Activate team mechanics',
      TeamSize: 'Users per team',
      LandingScreen: 'Landing screen',
      Image: 'Image',
      ImageHelpText: 'Min size 360(w) x 144(h) px in jpg or png',
      PreEnrollmentMessage: 'Pre-enrollment message',
      StampsEarnMessage: 'Stamps earn message',
      GameplayInstructions: 'Gameplay instructions',
      JoinTeamPage: 'Join team page',
      JoinTeamInfoMessage: 'Join team info message',
      InviteMemberMessage: 'Invite member message',
      InviteCodeBlurb: 'Invite code blurb',
      CharactersUsed: 'Characters used',
      Note: 'Note',
      NoteDescriptionOne: 'Both the',
      NoteDescriptionTwo: 'invite member message',
      NoteDescriptionThree: 'and the',
      NoteDescriptionFour: 'invite code blurb',
      NoteDescriptionFive:
        'are used to generate the “share message”. We’ve placed no limitation to the length of this message - but keep in mind that SMS messages have a limit of 160 characters per message',

      DefaultPreEnrollmentMessagePartOne: 'Create or join a {{teamSize}}-member team',
      DefaultPreEnrollmentMessagePartTwo: 'You can create or join 1 team.',
      DefaultStampsEarnMessagePartOne: 'Earn stamps by doing any of the following',
      DefaultStampsEarnMessagePartTwo: 'Do KYC',
      DefaultStampsEarnMessagePartThree: 'Switch to e-statements',
      DefaultParticipationInfoMessagePartOne: 'Earn rewards by doing any of the following',
      DefaultParticipationInfoMessagePartTwo: 'Do KYC',
      DefaultParticipationInfoMessagePartThree: 'Switch to e-statements',
      DefaultTeamCompleteButtonText: 'Check your progress',
      DefaultTeamCompleteButtonTextStamp: 'See your stamp cards',
      DefaultTeamIncompleteButtonText: 'Join A Team',
      DefaultTeamIncompleteButtonTextSecondary: 'Create A Team',
      DefaultJoinTeamPageDescriptionPartOne:
        'A team is only considered active once {{teamSize}} members have committed to join.',
      DefaultJoinTeamPageDescriptionPartTwo:
        'Enter the code/url on the field above and click on join',
      DefaultJoinTeamPageDescriptionPartThree: 'Wait until {{teamSize}} members have committed',
      DefaultJoinTeamPageDescriptionPartFour: 'Collect stamps as a team',
      DefaultJoinTeamPageDescriptionPartFive: 'Play games as a team',
      DefaultJoinTeamPageDescriptionPartSix:
        'Individuals can only be part of 1 team (whether created or joined)',
      DefaultInviteMessageDescriptionPartOne: 'Hi, please join my team to',
      DefaultInviteMessageDescriptionPartTwo: ' fill out stamp cards and get prizes together!',
      DefaultInviteMessageDescriptionPartThree: ' play games ',
      DefaultInviteMessageDescriptionPartFour: ' and get prizes together!',
      DefaultInviteMessageCodeBlurb: 'Use my team code:'
    },

    EnrolMechanics: {
      EnrolmentMechanics: 'Enrolment mechanics',
      AutoEnrolUsers: 'Auto-enrol users',
      EnrollableUntil: 'Enrollable until',
      AutoFillStamps: 'Auto-fill stamps',
      EnableCampaignDurationMechanics: 'Enable campaign duration mechanics',
      UsersMustCompleteTheCampaignWithin: 'Users must complete the campaign within',
      AutoRedeemOutcome: 'Auto redeem outcome',
      SendMicrositeNotification: 'Send Microsite notification for auto redeem outcome?',
      Yes: 'Yes',
      No: 'No'
    },

    StreakMechanics: {
      StreakMechanics: 'Streak mechanics',
      SelectTaskType: 'Select task type',
      CumulativeSpend: 'Cumulative Spend',
      TransactionCount: 'Transaction Count',
      SignIn: 'Sign In',
      StreakRequirements: 'Streak Requirements',
      TargetCriteria: 'Target Criteria',
      UserMustPerformTheTask: 'User must perform the task',
      TimesWithinOne: 'times within 1',
      StreakTarget: 'Streak Target',
      Continuous: 'continuous',
      Days: 'days',
      Weeks: 'weeks',
      Months: 'months',
      SelectTrigger: 'Select Trigger',
      MilestonesAndPrizes: 'Milestones and Prizes',
      TargetMake: 'Target: Make',
      ValidTransactionsEvery: 'valid transactions every',
      For: 'for',
      Level: 'Level',
      MustBeMoreThanLevel: 'must be more than level',
      SelectStreakDuration: 'Select streak duration',
      Daily: 'Daily',
      Weekly: 'Weekly',
      Monthly: 'Monthly',
      AtLeastOneConditionIsRequired: 'At least one condition is required',
      CustomerSignIn: 'Customer Sign In',
      TransactionCreated: 'Transaction Created',
      TargetSpend: 'Target: Spend',
      CurrencyEvery: 'currency every',
      TargetSignIn: 'Target: Sign In',
      TimesEvery: 'times every',
      Perform: 'perform',
      Signin: 'sign in',
      Transaction: 'transaction',
      Spend: 'spend',
      PerformTheTask: 'perform the task',
      InOrderToWinThePrize: 'in order to win the prize',
      MakeTransactionAtLeast: 'make transaction at least',
      Times: 'times',
      AtLeast: 'at least',
      Where: 'where',
      CurrencyOnTransactionsWhere: 'currency, on transactions where',
      MakeTransaction: 'make transaction'
    },

    LandingPage: {
      Title: 'Landing page',
      Headline: 'Headline',
      SubHeadline: 'Sub-headline',
      BodyText: 'Body text',
      Image: 'Image',
      CTAButtonText: 'CTA Button text',
      CTAButtonColour: 'CTA Button colour',
      CTAButtonTextColour: 'CTA Button text colour',
      TermsAndConditions: 'Terms and conditions',
      EnrolmentMessage: 'Enrolment message',
      ImageHelpText: '16:9 aspect ratio recommended, 500kb max in jpg or png',
      IssuePrizeDescription: 'Issue prize description',
      IssuePrizeDescriptionPlaceholder: 'Please input your issue prize description',
      PleaseInputYourHeadline: 'Please input your headline',
      PleaseInputYourSubHeadline: 'Please input your sub headline',
      PleaseInputYourBodyText: 'Please input your body text',
      ImageMinRequirements: 'Min size 360(w) x 144(h) px in jpg or png',
      AspectRatioRecommendation: '16:9 aspect ratio recommended, 500kb max in jpg or png',

      LevelsTab: "'Levels' Tab",
      HowToParticipateTab: "'How to participate' Tab",
      TabName: 'Tab name',
      CampaignPointsShortForm: 'Campaign points short form',
      LevelProgressBadges: 'Level progress badges',
      LevelCompletedBadge: "'Level completed' badge",
      LevelInProgressBadge: "'Level in progress' badge",
      LevelNotStartedBadge: "'Level not started' badge",
      LevelCompletedBadgeHelpText: '92px by 92px recommended, 100kb max in jpg or png',
      IssuePrizelabel: "'Issue prize' Description",
      LevelCompletedBadgeIcon: 'Level {{index}} icon',
      Text: 'Text',

      CompleteLevelAndStandToWinAPrizeSetIncluding:
        'Complete level & stand to win a prize set including:',
      ParticipateAndWinExcitingPrizes: 'Participate and win exciting prizes!',
      HowToParticipate: 'How to participate',
      AddLevel: 'Add level',
      PointsRequiredForCampaignCompletion: 'Points required for campaign completion:',

      OutcomeSettings: {
        Title: 'Outcome Settings',
        Badges: 'Badges',
        Vouchers: 'Vouchers',
        Points: 'Points',
        PrizeSet: 'Prize Set',
        MixedRewards: 'Mixed Rewards',
        Submit: 'Submit',
        MixedRewardsButtonText: 'Button text based on first reward listed',
        Headline: 'Headline',
        CharactersLeft: 'characters left',
        MixedRewardsMessage:
          'For a prize set, the button text and action will be based on the first reward listed in the outcomes.',
        ButtonText: 'Button text',
        Graphic: 'Graphic',
        GraphicHelpText: 'w: 400px  ×  h: 400px',

        BadgesHeadline: "Congratulations! You've won a badge!",
        BadgesButtonText: 'Show My Badges',
        VouchersHeadline: "Congratulations! You've won a voucher!",
        VouchersButtonText: 'Go to My Vouchers',
        PointsHeadline: "Congratulations! You've won some points!",
        PointsButtonText: 'See My Points',
        MixedRewardsHeadline: "Congratulations! You've won some rewards!"
      },

      EndsOnDate: 'Ends on {{date}}',
      FromDate: 'From {{date}} onwards',
      ParticipateAndStandToWin: 'Participate and stand to win ONE of the following:',
      CongratsYouEarnedAPrize: 'Congrats, you earned a prize!',
      ClaimNowBeforeTheRunOut: 'Claim now before they run out!',
      ClaimPrize: 'CLAIM PRIZE',

      Levels: 'Levels',
      PointsAbbreviation: 'CP'
    },

    StampCampaign: {
      Config: {
        Title: 'Select Number of Stamps',
        TotalStampsOnCard: 'Total stamps on card',
        TotalStamps: 'Total stamps',
        StampsPerRow: 'No. of stamps per row (max 5)',
        StampsPerRowPlaceholder: '(Optional) Specify stamps per row',
        StampsPerColumn: 'No. of stamps per column',
        StampsPerColumnPlaceholder: '(Optional) Specify stamps per column'
      },
      TriggerConfig: {
        Title: 'Set stamp earn rules'
      },
      CardBackground: {
        Title: 'Card Image',
        HeaderMessage: 'Header message',
        Subheadline: 'Subheadline',
        Backgrounds: 'Backgrounds',
        BackgroundImage: 'Background image',
        RemoveImage: 'Remove image',
        BrowseFiles: 'BROWSE FILES',
        CardBackgroundImage: 'Card background image',
        CardBackgroundImageAlt: 'Stamp card background',
        ThumbnailImage: 'Thumbnail image',
        ThumbnailImageAlt: 'Stamp thumbnail',
        Elements: 'Elements',
        GiftActive: 'Gift (Active)',
        GiftActiveAlt: 'Gift',
        GiftInactive: 'Gift (Inactive)',
        GiftInactiveAlt: 'Gift (Inactive)',
        StampActive: 'Stamp (Active)',
        StampActiveAlt: 'Stamp',
        StampInactive: 'Stamp (Inactive)',
        StampInactiveAlt: 'Stamp (Inactive)',
        ButtonText: 'Button text',
        ButtonExternalLink: 'Button external link',
        ButtonColour: 'Button colour',
        ButtonTextColour: 'Button text colour'
      },
      LimitConfig: {
        Title: 'Stamp Limits',
        TotalStampCards: 'Total stamp cards',
        TotalStampCardsPerUser: 'Total stamp cards per user',
        TotalStampsPerUser: 'Total stamps per user',
        TotalStamps: 'Total stamps',
        Every: 'every',
        Days: 'Days',
        Months: 'Months',
        Year: 'Year',
        Weeks: 'Weeks'
      },

      AutoEnrolMechanic: {
        Title: 'Campaign mechanics',
        OperatingDays: 'Operating days',
        From: 'From',
        To: 'To'
      }
    },

    Referral: {
      Title: 'Referral code types',
      CodeType: 'Code type',
      ReferredBy: 'Referred by',
      SelectFile: 'Select file',
      SystemGenerated: 'System generated',
      AlternateId: 'Alternate id',
      User: 'User',
      Partner: 'Partner',
      ActionMechanics: 'Action mechanics',

      UploadSingleFileFiled: {
        AcceptedFormat: 'Accepted formats: {{acceptedFormatsString}} files only',
        DownloadSample: 'Download sample',
        ChooseFile: 'Choose file'
      }
    },

    CampaignRulesTable: {
      Outcome: 'Outcome',
      Priority: 'Priority',
      TriggerLimitPerUser: 'Trigger limit per user',
      TotalTriggerLimit: 'Total trigger limit',

      Name: 'Name',
      CampaignPointsIssued: 'Campaign points issued',
      Action: 'Action',
      Edit: 'Edit',
      Remove: 'Remove'
    },

    RuleGroupLandingPage: {
      Title: 'Landing page',
      Headline: 'Headline',
      HeadlinePlaceholder: 'Please input your headline',
      SubHeadline: 'Sub-Headline',
      SubHeadlinePlaceholder: 'Please input your sub headline',
      BodyText: 'Body text',
      Image: 'Image',
      ImageHelpText: '16:9 aspect ratio recommended, 500kb max in jpg or png',
      ExpandableContentSections: 'Expandable content sections',
      SectionLabel: 'Section {{index}} label',
      SectionHeaderText: 'Section {{index}} header text',
      SectionBodyText: 'Section {{index}} body text',

      ExpandableSection: 'Expandable section',
      Label: 'Label',
      AddSection: 'Add section',
      Remove: 'Remove',

      ShopChooseRedeem: 'Shop. Choose. Redeem.'
    },

    RuleGroupEnrolmentPage: {
      Title: 'Enrolment page',
      BodyText: 'Body text'
    },

    GameSettings: {
      ShakeTheTreeSettings: 'Shake The Tree Settings',
      HeaderMessage: 'Header message',
      Header: 'Header',
      CharactersLeft: 'characters left',
      HeadlineTextColour: 'Headline text colour',
      Subheadline: 'Subheadline',
      Description: 'Description',
      GameDesign: 'Game design',
      BackgroundImage: 'Background image',
      TreeImage: 'Tree image',
      GiftIcon: 'Gift icon',
      GiftIconOpenState: 'Gift icon - open state',
      NumberOfGiftIcons: 'Number of gift icons',
      SubheadlineTextColour: 'Subheadline text colour',
      NumberOfTaps: 'Number of taps',
      PinataSettings: 'Pinata settings',
      AppBackground: 'App background',
      FontColour: 'Font colour',
      InitialPinata: 'Initial pinata',
      CrackingPinata: 'Cracking pinata',
      BrokenPinata: 'Broken pinata',
      ButtonText: 'Button text',
      ButtonColour: 'Button colour',
      ButtonTextColour: 'Button text colour',
      DisplayProperties: 'Display properties',
      Headline: 'Headline',
      AppGraphics: 'App graphics',
      ScratchCardGraphics: 'Scratch Card graphics',
      PreScratch: 'Pre-scratch',
      PostSuccess: 'Post (Success)',
      PostFail: 'Post (Fail)',
      SubheadlineColour: 'Subheadline colour',
      ScratchCardHeadline: 'Scratch card headline',
      SpinTheWheelHeadline: 'Spin the Wheel headline',
      SpinTheWheelGraphics: 'Spin The Wheel graphics',
      RewardIcon: 'Reward icon',
      NumberOfWedges: 'Number of wedges',
      NumberOfWedgesOnTheWheel: 'Number of wedges on the wheel',
      Wedge: 'Wedge',
      Color: 'Color',
      HasReward: 'Has reward',
      RimImage: 'Rim image',
      WheelPosition: 'Wheel position',
      Center: 'Center',
      Bottom: 'Bottom',
      PointerImage: 'Pointer image',
      PlinkoSettings: 'Plinko settings',
      Plinko: 'Plinko!',
      PlinkoGraphics: 'Plinko graphics',
      FrameColour: 'Frame colour',
      BallColour: 'Ball colour',
      GameDuration: 'Game duration',
      HowLongItTakesForTheBallToReachTheBottom:
        'How long it takes for the ball to reach the bottom',
      Seconds: 'seconds',
      SuggestedDuration: 'Suggested duration: 3~5 seconds',
      TargetType: 'Target type',
      Bubble: 'Bubble',
      Coins: 'Coins',
      Stars: 'Stars',
      BubbleSpawnRate: 'Bubble spawn rate',
      Easy: 'Easy',
      Medium: 'Medium',
      Hard: 'Hard',
      CTAButtonText: 'CTA Button text',
      CTAButtonColour: 'CTA Button colour',
      CTAButtonTextColour: 'CTA Button text colour',
      NumberOfBubbles: 'Bubble Pop Graphics',
      BubbleLabel: 'Bubble',
      GameSettings: 'Bubble Pop Settings',
      GameBackground: 'Game background',
      CustomSpawnRate: 'Custom spawn rate',
      MaxBubbles: 'Max. bubbles',
      SpawnInterval: 'Spawn interval (in milliseconds)',
      BubblesPerSpawn: 'Bubble per spawn',
      BubbleLifetime: 'Bubble lifetime (in milliseconds)',
      GameDurationNote: 'NOTE: Min. 10 seconds game duration is required.',
      MaxBubblesNote: 'NOTE: Maximum number of bubble to be displayed on the screen.',
      SpawnIntervalNote: 'NOTE: Bubble spawn interval in milliseconds',
      BubblesPerSpawnNote: 'NOTE: Number of bubble per spawned at once.',
      BubbleLifetimeNote: 'NOTE: Bubble lifetime in milliseconds',
      Type: 'Type',
      CustomImage: 'Custom Image',
      SVGCode: 'SVG Code',
      DownloadSampleSVG: 'Download Sample SVG',
      Points: 'Points',
      MarkAsBonus: 'Mark as Bonus',
      BonusImageOccurrence: 'Number of Bonus Bubble occurrence'
    },

    OutcomeSettings: {
      OutcomeSettings: 'Outcome settings',
      WinRewardTitle: 'Win reward title',
      CharactersLeft: 'characters left',
      WinRewardSubheadline: 'Win reward subheadline',
      WinRewardGraphic: 'Win reward graphic',
      NoOutcomeTitle: 'No outcome title',
      NoOutcomeSubheadline: 'No outcome subheadline',
      NoOutcomeGraphic: 'No outcome graphic',
      WinRewardButton: 'Win reward button',
      NoOutcomeButton: 'No outcome button'
    },

    GameLimits: {
      GameLimits: 'Game limits',
      AutoIssueMoves: 'Auto issue moves',
      AlwaysShowThisCampaignEvenIfOutOfGameTries:
        'Always show this campaign even if out of game-tries',
      TotalGameCampaignLimitsIs: 'Total game campaign limits is',
      NoteForInfiniteUsesLeaveBlank: 'NOTE: For infinite uses, leave the field blank.',
      IndividualUsersCanOnlyPlayThisGame: 'Individual users can only play this game',
      TimesInTotal: 'times in total',
      TimesPer: 'times per'
    }
  },

  [CampaignReviewPageKey]: {
    GameInfoTitle: 'Game info',

    GameInfo: {
      NumberOfTaps: 'Number of taps:',
      NumberOfGiftsShown: 'Number of gift icons:',
      NumberOfGiftsToDrop: 'Number of gift icons to drop:',
      CampaignLifetimeMaxMovesAvailable: 'Total game campaign limits:',
      AccountLifetimeMaxMovesAvailable: 'Individual users can only play this game times:',
      AccountIntervalMaxMovesAvailable: 'Individual users can only play this game:',
      Times: 'times',
      Per: 'per'
    },

    CampaignRequestComment: {
      Content: 'Content',
      DeleteButton: 'Delete button',
      Delete: 'Delete',
      Time: 'Time',

      Title: 'Pending Campaign',

      Description:
        'This campaign is pending reviews approval. Any comments added will show up here.',
      CommentsAdded: 'comments added',
      PointsExpiryUnit: 'Points Expiry (Days)',
      PointsExpiryPeriod: 'Points Expiry Period'
    },

    DeleteCommentModal: {
      SuccessMessage: 'Comment deleted',
      ErrorMessage: 'Error deleting comment',
      Title: 'Delete comment?',
      OkText: 'Delete',
      DescriptionLineOne: 'Are you sure you want to delete this comment?',
      DescriptionLineTwo: 'This action cannot be undone.',
      CancelText: 'Cancel'
    },

    ApproveDenyCampaignRequestModalTitle: 'Approve campaign?',
    ApproveDenyCampaignRequestModalButton: 'Approve',

    ApproveDenyCampaignRequestModal: {
      SuccessMessage: 'Request has been approved',
      ErrorMessage: 'Something Went Wrong',

      ApproveTitle: 'Approve campaign?',
      Title: 'Submit deletion request?',
      ApproveOkText: 'Approve',
      OkText: 'Request deletion',
      CancelText: 'Cancel',

      ApproveDescriptionLineOne: 'Are you sure you want to approve this campaign?',
      ApproveDescriptionLineTwo: 'This action cannot be undone.',

      DescriptionLineOne: 'This campaign is pending approval. Are you sure you want to delete it?',
      DescriptionLineTwo:
        'Once the deletion is approved, this campaign will not be available and you will need to create it again.'
    },

    AddCommentModalTitle: 'View and add comments',
    AddCommentModalButton: 'Add Comment',
    AddCommentModal: {
      SuccessMessage: 'Comment added',
      ErrorMessage: 'Error adding comment',
      CancelText: 'Cancel',
      CommentInputPlaceholder: 'Enter your comment here',
      AddCommentButton: 'Add comment'
    },

    CampaignInfoTitle: 'Campaign info',

    ReviewInfo: {
      Subtitle: 'Subtitle:',
      Description: 'Description:',
      TnC: 'Terms & conditions:',
      RiskDisclaimer: 'Risk disclaimer:',
      BranchName: 'Brand name:',
      Tags: 'Tags:',
      Categories: 'Categories:',
      Labels: 'Labels:',
      Catalogue: 'Catalogs:',
      UploadImages: 'Uploaded photos:',
      Merchant: 'Merchant:',
      CustomField: 'Custom fields:',
      Type: 'Type:',
      Url: 'Website URL:',
      Partner: 'Partner:',
      Reset: 'Reset:',
      Stackable: 'Stackable:',
      Status: 'Status:',
      Name: 'Campaign name:',
      CatalogueName: 'Catalogue Name:',
      Duration: 'Campaign duration:',
      StepsToRedeem: 'Steps to redeem:',
      ActiveAt: 'Active At:',
      Owner: 'Owner:',
      RewardLegacyAudience: 'Where can this reward be displayed:',
      RewardsCost: 'Rewards cost:',
      SellingPrice: 'Selling price:',

      OperatingDays: 'Operating Days:',
      OperatingPeriod: 'Operating Period:',

      ReviewMonth: 'Review Month:',
      PromotionSettings: 'Promotion Settings:',
      DemotionSettings: 'Demotion Settings:',
      PromoteUntil: 'Promote Until:'
    },

    SocialMediaReview: {
      CopyTextSuccessMessage: 'Social Media URL Copied!',
      Title: 'Social Media',
      OGTitle: 'Title',
      OGDescription: 'Description',
      OGImage: 'Image',
      OGImageAlt: 'Social media review',
      AlternativeIOSLinkDescription: 'iOS App link',
      AlternativeAndroidURLDescription: 'Android App Link',
      OGURL: 'Web Link',
      SocialMediaURL: 'Social Media URL',
      CopyURLButton: 'Copy URL',
      OGURLDescription: 'This link will be generated only after launch',
      WebLink: 'Web Link',
      Description: `The {{webLink}} field has to be filled for the Social Media URL to be generated`
    },

    AudienceInfoTitle: 'Audience Info',

    AudienceInfo: {
      Description: 'Selected audience:',
      NoListsSelected: 'No lists selected',
      Include: 'Include',
      Exclude: 'Exclude',
      AudienceAttributes: 'Audience attributes',
      AudienceList: 'Audience list'
    },

    EnrolmentSettings: 'Enrolment settings',
    AutoEnrolUsers: 'Auto-enrol users',
    EnrollableUntil: 'Enrollable until',
    AutoRedeemOutcome: 'Auto redeem outcome',
    SendMicrositeNotificationAutoRedeem: 'Send Microsite Notification for Auto Redeem Outcome?',
    StampMechanics: 'Stamp mechanics',
    TotalStampCards: 'Total stamp cards',
    TotalStampCardsPerUser: 'Total stamp cards per user',
    TotalStamps: 'Total stamps',
    TotalStampsPerUser: 'Total stamps per User',

    GameMechanics: {
      Title: 'Game mechanics',
      HitThePinata: {
        Title: 'Hit The Pinata',
        InstructionsLineOne:
          '1. End-user gets a reward based on completing a required action in this case by hitting the pinata.',
        InstructionsLineTwo:
          '2. Rewards are randomly issued out based on the probability set on the rewards',
        IdealFor: 'Ideal for',
        InstructionsLineThree: '1. Seasonal game',
        HeaderMessage: 'Header message',
        GameDesign: 'Game design',
        PlayButtonText: 'Play button text'
      },

      ShakeTheTree: {
        Title: 'Shake The Tree',
        InstructionsLineOne:
          'Engage customers with a challenge which requires them to shake the phone',
        GameMechanics: 'Game mechanics',
        InstructionsLineTwo:
          '1. End-user gets a reward based on completing a required action in this case by hitting the pinata',
        InstructionsLineThree:
          '2. Rewards are randomly issued out based on the probability set on the rewards',
        IdealFor: 'Ideal for',
        InstructionsLineFour: '1. Season game',
        HeaderMessage: 'Header message',
        GameDesign: 'Game design',
        TreeVisual: 'Tree visual',
        GiftVisual: 'Gift visual',
        PlayButtonText: 'Play button text'
      },

      BubblePop: {
        Title: 'Bubble Pop Properties',
        GameTitle: 'Bubble Pop Game',
        Description: 'Engage the customer with their skills.',
        BubbleSpawnRate: 'Bubble Spawn Rate',
        GameDuration: 'Game Duration',
        Seconds: 'seconds',
        GameBackground: 'Game background',
        NumberOfBubbles: 'Number of bubble',
        BubbleColors: 'Bubble colors',
        Bubble: 'Bubble',
        CustomImage: 'Custom image',
        Points: 'Points',
        IsBonus: 'is bonus?',
        Yes: 'Yes',
        No: 'No',
        MaxBubbles: 'max. bubble',
        SpawnInterval: 'spawn interval (in milliseconds)',
        BubblesPerSpawn: 'Bubble per spawn',
        BubbleLifetime: 'Bubble lifetime (in milliseconds)',
        CustomSpawnRate: 'Custom spawn rate'
      },

      QuizOrSurveyTypeGame: {
        Properties: 'Properties',

        GameMeta: {
          ScratchCard: 'Scratch Card',
          ScratchCardDetails:
            'Engage customers with a challenge which requires them to scratch a game card.',
          HitThePinata: 'Hit The Pinata',
          HitThePinataDetails:
            'Engage customers with a challenge which requires them to shake the phone.',
          ShakeTheTree: 'Shake The Tree',
          ShakeTheTreeDetails:
            'Engage customers with a challenge which requires them to top on the object.',
          SpinTheWheel: 'Spin The Wheel',
          SpinTheWheelDetails: 'Engage the customer with a wheel of fortune.',
          Plinko: 'Plinko',
          PlinkoDetails: 'Drop the ball and get some lucky bounces'
        },

        GameGraphics: {
          AppGraphics: 'App graphics',
          PreScratch: 'pre-scratch',
          PostSuccess: 'Post (success)',
          PostFail: 'Post (fail)',
          RewardIcon: 'Reward icon',
          NumberOfWedges: 'Number of wedges',
          WedgeColors: 'Wedge colors',
          Wedge: 'Wedge',
          WheelImage: 'Wheel image',
          WheelPosition: 'Wheel position',
          PointerImage: 'Pointer image',
          Headline: 'Headline',
          Subheadline: 'Subheadline',
          AppBackground: 'App background',
          ButtonText: 'Button text',

          FrameColor: 'Frame color',
          BallColor: 'Ball color',
          HeadlineTextColor: 'Headline text color',
          SubheadlineTextColour: 'Subheadline text colour'
        },

        Survey: 'Survey',
        SurveyDetails: 'Engage the customer with multiple choice questions.',
        Quiz: 'Quiz',
        QuizDetails: 'Engage the customer with multiple choice questions.',
        BackgroundImage: 'Background image',
        Submit: 'Submit'
      }
    },

    RewardLimits: {
      Title: 'Reward limits',
      DescriptionLineOne: 'Total number of rewards that can be issued:',
      DescriptionLineTwo: 'Number of rewards each user can receive:',
      DescriptionLineThree: 'Individual users can only play this game:',
      DescriptionLineFour: 'Campaign will only issue rewards:',
      InTotal: 'in total',
      Times: 'times',
      Per: 'per'
    },

    Rules: 'Rules',

    RulePreview: {
      ID: 'ID',
      RulesBalance: 'Rules balance',
      Of: 'of',
      Trigger: 'Trigger',
      Type: 'Type',
      Conditions: 'Conditions',
      EventName: 'Event name',
      CampaignId: 'Campaign id',
      RewardId: 'Reward id',
      LoyaltyId: 'Loyalty id',
      LoyaltyTierId: 'Loyalty tier id',
      AutomationTriggerId: 'Automation trigger id',
      Outcome: 'Outcome',
      NumberOfStamps: 'Number of stamps',
      AwardPoints: 'Award points',
      ForEveryCurrency: 'For every Currency',
      UpToAMaximumOfPoints: 'Up to a maximum of points',
      UserEarnsOneRaffleTicket: 'User earns 1 raffle ticket',
      TheTaskWillBeMarkedAsDone: 'The task will be marked as ‘done’',
      Points: 'Points',
      LoyaltyProgram: 'Loyalty program',
      Award: 'Award',
      GlAccountNumber: 'GL Account Number',
      GlAccountName: 'GL Account Name',
      CostCenterId: 'Cost Center Id',
      BranchCode: 'Branch Code',
      Reward: 'Reward',
      Name: 'Name',
      SellingFrom: 'Selling from',
      Limits: 'Limits',
      MaximumEvents: 'Maximum events',
      PerCampaign: 'per campaign',
      PerUser: 'per user',
      TriggerRateLimit: 'Trigger rate limit',
      PerUserForEvery: 'per user for every',
      SendPushNotificationLabel: 'Send push notification for every rule trigger?:',
      Attribute: 'Attribute',
      Operator: 'Operator',
      SelectedValues: 'Selected values',
      Conditionals: 'Conditionals',
      Condition: 'Condition',
      NA: 'N.A',
      PushNotificationRuleForInstantOutcomeTransactionIssue:
        'Push Notification Rule for Instant Outcome Transaction Issue',
      PushNotificationRuleForAutoRedeemInstantOutcomeTriggers:
        'Push Notification Rule for Auto Redeem Instant Outcome Triggers',
      CurrencyWithin1: 'currency within 1',
      UserMustPerform: 'User must perform',
      UserMust: 'User must',
      AtLeast: 'at least',
      TimesWithin1: 'times within 1',
      StreakCampaignMechanics: 'Streak campaign mechanics',
      SendPushNotificationForEveryRuleTrigger: 'Send push notification for every rule trigger?:',
      YES: 'YES',
      NO: 'NO',
      MediaTag: 'Media Tag:',
      CustomFields: 'Custom Fields:',
      StreakTarget: 'Streak Target',
      TargetCriteria: 'Target Criteria',
      StreakPeriod: 'Streak Period',
      Within: 'within',
      TransactionsWithin: 'transactions within'
    },

    ActionMechanics: 'Action mechanics',

    InstantRewardMechanics: 'Instant reward mechanics',
    InstantRewardMechanicsLabel: "Show campaign in user's campaign listing?",
    IssuanceLimits: 'Issuance limits',
    IssuanceLimitsLabel: 'Total number of issue-prize events (on campaign level)',
    AccountLifetimeMaxAvailableLabel: 'Total number of issue-prize events (per user)',
    RateLimitCampaignLabel: 'Rate limit (on campaign level)',
    RateLimitUserLabel: 'Rate limit (per user)',
    Outcomes: 'Outcomes',
    IssuePrizeEvents: 'issue-prize event(s)',
    LimitTo: 'Limit to',
    ForEvery: 'for every',

    PrizeSet: {
      Outcomes: 'outcomes',
      QuizSelectableOne: 'Award prizes for completing the quiz',
      QuizSelectableTwo: 'Award points per correct answer',
      PointsPerAnswerLabel: 'Points per correct answer:',
      Points: 'points',
      Edit: 'Edit',
      Remove: 'Remove',
      NoPrizeAdded: 'No prize added',
      Prizes: 'Prizes',
      AddRandomPrize: 'Add random prize',
      AddPrizeSet: 'Add prize set',
      AddRewards: 'Add rewards',
      AwardPoints: 'Award points',
      AwardBadges: 'Award badges',
      AddPrize: 'Add prize',
      IncludeNoPrizeAsOutcome: 'Include no prize as outcome',

      GLACDetail: 'GL Account Detail',
      GLACNo: 'GL A/C No',
      GLACName: 'GL A/C Name',
      GLACType: 'GL A/C Type',
      CostCenterID: 'Cost Center ID',
      BranchCode: 'Branch Code',

      WinOdds: 'Win odds',
      Prize: 'Prize',
      Merchant: 'Merchant',
      Balance: 'Balance',

      GameTry: 'Game try',
      GameTryCampaignSelectWarningText:
        'Only campaigns with auto-issue game tries disabled can be selected for issuing game tries.',
      GameTryCampaignID: 'Game Try Campaign ID: {{campaignId}}',
      NumberofGameTries: 'Number of Game Tries',
      NoOutcome: 'No outcome'
    },

    PrizePerAnswer: {
      CountOfPointsValidationMessage: 'Please specify a Count of Points per answer',
      LoyaltyProgramValidationMessage: 'Please select a loyalty program',
      Title: 'Points Per Correct Answer',
      OkText: 'Save',
      CancelText: 'Cancel',
      LoyaltyProgramLabel: 'Select a loyalty program',
      LoyaltyProgramSelectPlaceholder: 'Select loyalty program',
      CountOfPointsLabel: 'Award'
    },

    RewardSelectModal: {
      Title: 'Select a reward',
      OkText: 'Add reward',
      CancelText: 'Cancel',
      SearchPlaceholder: 'Find a reward by name, id or merchant',
      ID: 'ID',

      Tabs: {
        All: 'All',
        Active: 'Active',
        Approved: 'Approved',
        Private: 'Private',
        System: 'System'
      },

      Reward: 'Reward',
      Merchant: 'Merchant',
      Balance: 'Balance',
      SellingFrom: 'Selling from',
      SellingTo: 'Selling to'
    },

    IssuePointsModal: {
      ShowVariablePointsValidationMessage: 'Please specify a Count of Points',
      LoyaltyProgramValidationMessage: 'Please specify a loyalty program',
      ShowVariablePointsOutcomeValidatioMessage: 'This field is required',
      GLAccountTypeValidationMessage: 'Please select a GL Account Type',
      GLAccountNameValidationMessage: 'Please select a GL Account Name',
      GLAccountIDValidationMessage: 'Please select a GL Account',

      PleaseEnterAGreaterThanZero: 'Please enter a value greater than 0.',
      PleaseSpecifyTheNumberOfDays: 'Please specify the number of days.',
      DaysMustBeAtLeastOne: 'Days must be at least 1.',
      AwardedPointsExpireIn: 'Awarded points expire in',
      NumberOfDaysToExpirePlaceholder: 'e.g., 7',
      Days: 'days',

      FixedPoints: 'Fixed points',
      VariablePoints: 'Variable points',

      IssuePoints: 'Issue Points',
      Save: 'Save',
      Cancel: 'Cancel',
      SelectLoyaltyProgramLabel: 'Select a loyalty program',
      ShowVariablePointsAlertMessage:
        'You can either award fixed points or variable points. For variable points, user’s latest transaction will be considered.',
      NumberOfPointsToAward: 'Number of points to award',
      NumberOfPointsToAwardPlaceholder: 'eg.10',
      SelectGLAccount: 'Select GL Account',
      SelectGLAccountPlaceholder: 'Select GL Account',
      GLAccountType: 'GL Account Type',
      GLAccountTypePlaceholder: 'GL Account Type',
      GLAccountName: 'GL Account Name',
      GLAccountNamePlaceholder: 'GL Account Name',

      AwardedPointsExpire: 'Awarded points expire',
      AfterXDays: 'after',
      OnCampaignEndDate: 'on campaign end date',
      OnASpecificDate: 'on a specific date',
      CampaignEndDateNotSet: 'Campaign must have an end date to use this option.',
      CampaignEndDateRequired:
        "Error: Campaign end date is required. Please set an end date or disable 'On campaign end date' point expiry option.",
      PointsWillExpireOnEndDate: 'Points will expire on {{date}} on the campaign end date.',
      SelectExpiryDateTime: 'Select expiry date and time',
      PleaseSelectExpiryMode: 'Please select an expiry option.',
      PleaseSelectAnExpiryDate: 'Please select an expiry date.',
      PleaseSelectAnExpiryTime: 'Please select an expiry time.',
      ExpiryDateMustBeInTheFuture: 'Expiry date must be in the future.',
      AwardedPointsExpireOnCampaignEndDate: "Awarded points expire on campaign's end date",
      AwardedPointsExpireOn: 'Awarded points expire on',
      OnCampaignEndDateSuffix: "on the campaign's end date"
    },

    VariablePointsPane: {
      Transaction: 'Transaction',
      Award: 'Award',
      Every: 'Every',
      UpToAMaximumAmountOf: 'Up to a maximum amount of'
    },

    BadgeSelectModal: {
      Title: 'Select badge to display',
      OkText: 'Add badge',
      CancelText: 'Cancel'
    },

    BadgeListTable: {
      Name: 'Name',
      StartDate: 'Start date',
      EndDate: 'End date',
      Actions: 'Actions',
      ID: 'ID',
      SearchBadgesPlaceholder: 'Search badges',
      Edit: 'Edit',
      Deactivate: 'Deactivate',
      Activate: 'Activate',
      ErrorSortingBadgeMessage: 'Error sorting the badge.',
      ErrorUpdatingBadgeStateMessage: 'Error updating badge state',
      Status: 'Status'
    },

    ReviewOutcomesDisplay: {
      IncludeNoOutcome: 'Include no outcome',
      All: 'All',
      Active: 'Active',
      Approved: 'Approved',
      Inactive: 'Inactive',
      Ended: 'Ended',
      Private: 'Private',
      Points: 'Points',
      Custom: 'Custom'
    },

    StampCampaignOutcomes: {
      GLAccountNo: 'GL A/C No',
      GLAccountName: 'GL A/C Name',
      CostCenterID: 'Cost Center ID',
      GLAccountDetail: 'GL Account Detail',

      Slot: 'Slot',
      OutcomeType: 'Outcome type',
      AddRewards: 'Add rewards',
      AwardPoints: 'Award points',
      AwardBadges: 'Award badges',
      AddPrizeToSet: 'Add prize to set',
      IncludeNoPrizeAsOutcome: 'Include no prize as outcome',
      AddAnotherReward: 'Add another Reward',
      AddAnotherBadge: 'Add another Badge',
      RewardName: 'Reward name',
      NumberOfPoints: 'Number of points',
      ID: 'ID',
      Reward: 'Reward',
      Action: 'Action',
      Delete: 'Delete',
      NoOutcome: 'No outcome',
      ChangeByAddingReward: 'change by adding reward',
      AddFixedPrizeSet: 'Add fixed prize set',
      AddRandomPrize: 'Add random prize',
      IssueReward: 'Issue reward',
      IssuePoints: 'Issue points',
      IssueBadges: 'Issue badges',
      SlotsWithOutcomeAdded: 'Slots with Outcome added',
      PleaseEnterPrizeTitle: 'Please enter your prize title',
      PrizeTitleRequired: 'Prize title is required'
    },

    OutcomeSettings: {
      Title: 'Outcome Settings',
      PrizeSet: 'Prize Set',
      Submit: 'Submit',
      MixedRewardsButtonText: 'Button text based on first reward listed',
      Headline: 'Headline'
    },

    GameOutcomeScreens: {
      QuizScreens: 'Quiz screens',
      SurveyScreens: 'Survey screens',
      LandingPage: 'Landing page',
      LandingScreenHeading: 'Landing screen heading',
      LandingScreenSubheading: 'Landing screen subheading',
      LandingScreenButtonText: 'Landing screen button text',
      LandingScreenText: 'Landing screen text',
      OutcomeScreen: 'Outcome screen',
      SuccessfulOutcomeImage: 'Successful outcome image',
      SuccessfulOutcomeMessage: 'Successful outcome message',
      SuccessfulOutcomeButton: 'Successful outcome button',
      NoOutcomeMessage: 'No outcome message',
      NoOutcomeButton: 'No outcome button',
      NoOutcomeGraphic: 'No outcome graphic',
      OutcomeScreens: 'Outcome screens',
      WinRewardGraphic: 'Win reward graphic',
      WinRewardMessage: 'Win reward message',
      WinRewardButton: 'Win reward button'
    },

    TeamMechanics: 'Team mechanics',
    MemberPerTeam: 'Member per team',
    DisplaySetup: 'Display setup',
    LandingPage: 'Landing page',
    PreEnrolmentMessage: 'Pre-enrolment message',
    StampsEarnMessage: 'Stamps earn message',
    JoinTeamPagePreview: {
      Title: 'Join a Team',
      ButtonText: 'Join team',
      InputPlaceholder: 'Team code'
    },
    JoinTeamPage: 'Join team page',
    JoinTeamInfoMessage: 'Join team info message',
    InviteMemberMessage: 'Invite member message',
    InviteMemberMessageDescription: 'Invite member message description',
    InviteMemberMessageBlurb: 'Invite member message blurb',

    QuestMechanics: 'Quest mechanics',
    UserTriesValidity: 'User-tries validity',
    Task: 'Task',
    QuestTask: {
      AddRule: 'Add rule',
      Required: '*required'
    },
    TotalQuests: 'Total number of quests that can be started in a campaign',
    TotalQuestsPerUser: 'Total number of quests that can be started by each user',
    DisplaySetItup: 'Display set up',

    CampaignRuleFormModal: {
      Title: 'Campaign rule',
      RuleName: 'Rule name',
      Priority: 'Priority',
      Outcome: 'Outcome',
      Edit: 'Edit',
      Create: 'Create',
      Update: 'Update',
      Add: 'Add',
      CancelText: 'Cancel',
      RequiredErrorMessage: 'This field is required.',
      OutcomeRewardRequiredErrorMessage: 'Please select a reward',
      OutcomePointsRequiredErrorMessage: 'Please select a loyalty program',
      GLAccountTypeRequiredErrorMessage: 'Please select a GL Account Type',
      GLAccountNameRequiredErrorMessage: 'Please select a GL Account Name',
      OutcomeRequiredErrorMessage: 'This field is required',
      StampsWillBeIssued: 'Stamp(s) will be issued',
      FixedPoints: 'Fixed Points',
      VariablePoints: 'Variable Points',
      EarnType: 'Earn type',
      Award: 'AWARD',
      Points: 'Points',
      ForEvery: 'FOR EVERY',
      Currency: 'Currency',
      UpToAMaximumOf: 'UP TO A MAXIMUM OF',
      QuestOutcomeSegment: 'The task will be marked as ‘done’',
      InviteOutcomeSegment: 'The task will be marked as ‘done’',
      RaffleOutcomeSegment: 'User will earn a raffle ticket',
      SelectOutcomeType: 'Select outcome type',
      Reward: 'Reward',
      ChangeReward: 'Change reward',
      SelectReward: 'Select reward',
      SelectLoyaltyProgram: 'Select loyalty program',
      NumberOfPoints: 'Number of points',
      SelectGLAccount: 'Select GL Account',
      GLAccountType: 'GL Account Type',
      GLAccountTypePlaceholder: 'type',
      GLAccountName: 'GL Account Name',
      GLAccountNamePlaceholder: 'name',
      ValidityPeriod: 'Validity Period',

      ValidationMessages: {
        PleaseSelectATriggerEvent: 'Please select a trigger event',
        PleaseSelectALoyaltyProgramValue: 'Please select a loyalty program value',
        PleaseSelectALoyaltyTierValue: 'Please select a loyalty tier value',
        PleaseSelectACampaign: 'Please select a campaign',
        PleaseSelectAStampCampaign: 'Please select a stamp campaign',
        PleaseEnterTheNumberOfStamps: 'Please enter the number of stamps',
        NumberOfStampsMustBeAtLeastOne: 'Number of stamps must be at least 1',
        StampPositionMustBeAtLeastOne: 'Stamp position must be at least 1',
        PleaseEnterTheStampPosition: 'Please enter the stamp position',
        PleaseSelectAnAutomationTrigger: 'Please select an automation trigger',
        IntervalCannotBeLessThanZero: 'Interval cannot be less than zero',
        IntervalCannotBeGreaterThan365: 'Interval cannot be greater than 365',
        PleaseEnterTheInterval: 'Please enter the interval',
        PleaseSelectAMilestone: 'Please select a milestone',
        PleaseSelectARule: 'Please select a rule',
        PleaseSelectAReward: 'Please select a reward',
        ThisFieldIsRequired: 'This field is required',
        TheFieldIsRequired: 'The field is required',

        AttributeIsRequired: 'Attribute is required',
        OperatorIsRequired: 'Operator is required',
        PleaseSelectAtLeastOneDay: 'Please select at least one day',
        PleaseSelectATime: 'Please select a time',
        FromTimeMustBeLessThanToTime: 'From time must be less than to time',
        PleaseSelectAFormTime: 'Please select a form time',
        PleaseSelectAnToTime: 'Please select an to time',
        PleaseConfigureTheRuleTriggerDays: 'Please configure the rule trigger days',

        PleaseConfigureTheTrigger: 'Please configure the trigger',
        PleaseFillInTheNameOfTheRule: 'Please fill in the name of the rule',
        PleaseSelectAnOwner: 'Please select an owner',
        PleaseSelectATriggerRule: 'Please select a trigger rule',
        PleaseSpecifyAStartTime: 'Please specify a start time',
        PleaseSpecifyAValidEndTime: 'Please specify a valid end time',
        PleaseSelectAnOutcomeType: 'Please select an outcome type',
        PleaseSelectAMediaTag: 'Please select a media tag',
        PleaseSelectAGLAccountType: 'Please select a GL Account Type',
        PleaseSelectAGLAccountName: 'Please select a GL Account Name',
        GLAccountIDIsRequired: 'GL Account ID is required',
        PleaseEnterAKey: 'Please enter a key',
        AtLeastOneOutcomePropertyIsRequired: 'At least one outcome property is required',
        OutcomePropertiesAreRequired: 'Outcome properties are required',
        ValueMustBeGreaterThanZero: 'Value must be greater than zero.',
        ValueCannotBeZero: 'Value cannot be zero.',
        PleaseEnterANumber: 'Please enter a number',
        NumberMustBeAPositiveNumber: 'Number must be a positive number',

        OutcomeRequiredErrorMessage: 'This field is required',
        OutcomePointsRequiredErrorMessage: 'Please select a loyalty program'
      }
    },

    SelectTriggerSection: {
      SelectATrigger: 'Select a trigger',
      Custom: 'Custom',
      Transaction: 'Transaction',
      Loyalty: 'Loyalty',
      Campaign: 'Campaign',
      Customer: 'Customer',
      Reward: 'Reward',
      Location: 'Location',
      SelectTrigger: 'Select Trigger',
      SelectATriggerPlaceholder: 'Please select a trigger',
      Others: 'Custom',
      LoyaltyTrigger: {
        HelpText:
          'The number of points about to expire will be checked at the beginning of every review cycle.',
        AchievedNextTier: 'Achieved Next Tier',
        TenPercentCloseToNextTier: '10% Close To Next Tier',
        PointsIssued: 'Points Issued',
        AgeingPoints: 'Ageing points (points about to expire in the current cycle)',
        SelectLoyaltyProgram: 'Select Loyalty Program',
        SelectNextTier: 'Select Next Tier',
        SelectNextTierPlaceholder: 'Please select a loyalty tier'
      },
      RewardTrigger: {
        RedeemReward: 'Redeem Reward',
        IssueReward: 'Issue Reward',
        IssueRewardFromCampaign: 'Issue Reward From Campaign',
        IssueRewardFromMerchant: 'Issue Reward From Merchant',
        VoucherForParticularRewardExpiringIn: 'Voucher for particular Reward expiring in',
        AnyVoucherExpiringIn: 'Any voucher expiring in {{days}}'
      },

      MilestoneTrigger: {
        StampRedeemed: 'Stamp Redeemed',
        StampsIssued: 'Stamps Issued',
        StampsInactive: 'Stamps Inactive',
        GamePlayed: 'Game Played',
        GameTryIssued: 'Game Try Issued',
        CampaignEnrolled: 'Campaign Enrolled',
        CampaignCompleted: 'Campaign Completed',
        CampaignNotCompleted: 'Campaign Not Completed',
        ProgressLevelAchieved: 'Progress Level Achieved',
        ProgressRuleTriggered: 'Progress Rule Triggered',
        QuestTaskCompleted: 'Quest Task Completed',

        SelectAStampCampaign: 'Select a Stamp Campaign',
        Change: 'Change',
        Select: 'Select',
        Stamp: 'Stamp',
        Campaign: 'Campaign',
        ID: 'ID',
        FooterMsg: 'Any {{isCampaignRewardsSelected}} rewards in this campaign will be a trigger',
        SelectStampsSlot: 'Select Stamps Slot',
        StampCardPosition: 'Stamp Card Position'
      },

      CustomerTrigger: {
        SignUp: 'Sign-up',
        SignIn: 'Sign In',
        ProfileUpdated: 'Profile Updated'
      },

      TransactionTrigger: {
        SelectATriggerPlaceholder: 'Choose One...',
        FromDate: 'From Date',
        ToDate: 'To Date',
        SelectOperator: 'Select Operator',
        PropertyDataType: 'Property data type',
        Key: 'Key',
        Operator: 'Operator',
        Sunday: 'Sunday',
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
        Value: 'Value',
        PleaseSeparateMultipleValuesUsingComma: 'Please separate multiple values using comma',
        SelectTrigger: 'Select Trigger',
        And: 'And',
        AddCondition: 'Add Condition'
      },

      LocationTrigger: {
        EnterLocationDetails: 'Enter Location Details',
        Latitude: 'Latitude',
        Longitude: 'Longitude',
        LatitudeDegrees: 'Degrees ( -90.0 to 90.0 )',
        LongitudeDegrees: 'Degrees ( -180.0 to 180.0 )',
        PermissibleRadius: 'Permissible Radius (In Meter)',
        Radius: 'Permissible Radius',
        Preview: 'PREVIEW'
      },

      CampaignSelectField: {
        Interval: 'Interval',
        Days: '(Days)',
        SelectAStampCampaign: 'Select a Stamp Campaign',
        Change: 'Change',
        Select: 'Select',
        Stamp: 'Stamp',
        SelectACampaign: 'Select a campaign',
        Edit: 'Edit',
        Add: 'Add',
        Campaign: 'Campaign',
        SelectAMilestone: 'Select a Milestone',
        SelectARule: 'Select a Rule',
        SelectATask: 'Select a Task'
      },

      GameSelectField: {
        SelectAGameCampaign: 'Select a Game Campaign',
        Game: 'Game',
        Campaign: 'Campaign',
        Change: 'Change',
        Select: 'Select'
      },

      CampaignRewardSelectField: {
        SelectACampaign: 'Select a Campaign',
        Change: 'Change',
        Select: 'Select',
        Campaign: 'Campaign',
        SelectAReward: 'Select a Reward (Optional)',
        Reward: 'Reward'
      },

      MerchantRewardSelectField: {
        SelectAMerchant: 'Select a Merchant',
        Change: 'Change',
        Select: 'Select',
        Merchant: 'Merchant',
        AddMerchant: 'Add Merchant',
        Cancel: 'Cancel',
        SearchMerchant: 'Search merchant by name or ID',
        Active: 'Active',
        Inactive: 'Inactive'
      },

      RewardSelectField: {
        SelectAReward: 'Select a Reward (Optional)',
        Change: 'Change',
        Reward: 'Reward',
        Select: 'Select',
        WarningText: 'Outcome Type is limited to [Push Event] when a System reward is selected'
      },

      RewardExpirySetupField: {
        SelectAReward: 'Select a Reward',
        Change: 'Change',
        Select: 'Select',
        Reward: 'Reward',
        Periods: 'Periods (Days)'
      }
    },

    RuleTriggerLimitSegment: {
      Title: 'Trigger limits:',
      TotalTriggerEvents: 'Total number of trigger events (on campaign level)',
      TotalTriggerEventsPerUser: 'Total number of trigger events (per user)',
      TriggerRateLimitPerUser: 'Trigger rate limit (per user)',
      LeaveTheLimitFieldsBlankForUnlimitedTriggerEvents:
        '- Leave the limit fields blank for unlimited trigger events -',
      Days: 'Days',
      Weeks: 'Weeks',
      Months: 'Months',
      Years: 'Years',
      TriggerEventForEvery: 'trigger event(s) for every',
      AccountIntervalLimitPlaceholder: 'e.g., 2',
      AccountIntervalUnitsPlaceholder: 'e.g., 1',
      TriggerLimitPlaceholder: '∞',
      TriggerAccountLimitPlaceholder: '∞',
      LimitTo: 'Limit to'
    },

    RuleAudience: {
      SelectFilters: 'Select filters',
      Age: 'Age',
      Gender: 'Gender',
      Location: 'Location',
      Language: 'Language',
      Device: 'Device',
      Browser: 'Browser',
      Customs: 'Customs',
      Ethnicity: 'Ethnicity',
      Loyalty: 'Loyalty',
      EmailTags: 'Email Tags',
      BirthMonth: 'Birth Month',
      NoFiltersSelected: 'No filters selected',
      SelectedFilters: 'Selected filters'
    },

    LoyaltyTier: {
      Includes: 'includes',
      UsersWhoAchieved: 'Users who achieved',
      SelectProgramAndTier: 'Select program and tier'
    },

    LevelsAndPrizes: 'Levels & Prizes',

    LevelWrapper: {
      ValidatePointHelpMessage:
        'Level {{level}} points must be more than level {{previousLevel}} points!',
      LevelTitle: 'Level {{level}} display',
      TotalCampaignPointsRequired: 'Total campaign-points required to complete this level:'
    },

    ClaimPrizePopUp: '`Claim prize` pop up',

    LandingPagePreview: {
      CampaignName: 'Campaign name',
      Description: 'Description',
      TermsAndConditions: 'Terms and conditions',
      PRIZE: 'PRIZE',
      PrizeSet: 'Prize set',
      StartPlaying: 'Start playing'
    },

    EnrolmentPage: 'Enrolment page',

    RuleGroupLandingPagePreview: {
      CampaignName: 'Campaign name',
      EnrollText: 'ENROLL',
      EnrollNow: 'Enroll now',
      TermsAndConditions: 'General terms and conditions'
    },

    RaffleReview: {
      DisplaySettings: 'Display settings',
      LandingPage: 'Landing page',
      RaffleTicket: 'Raffle ticket',
      GrandPrize: 'Grand prize',
      GrandPrizes: 'Grand prizes'
    },

    DrawSection: {
      RaffleDraw: 'Raffle draw',
      DownloadCSV: 'Download CSV',
      GenerateRaffleWinners: 'Generate raffle winners',
      SomethingWentWrong: 'Something went wrong',
      RaffleCampaignPending: `The raffle campaign has ended. Click on ‘Generate raffle winners’ to trigger the raffle \
            draw and automatically award prizes to the winners. You will be able to see the list of \
            winners once the draw is complete.`,
      RaffleCampaignSuccess:
        'The raffle draw is complete and the winners have been awarded the grand prizes.'
    },

    GenerateWinnerModal: {
      GeneratingRaffleWinners: 'Generating raffle winners...'
    },

    RaffleWinnersTable: {
      Position: 'Position',
      FirstName: 'First name',
      LastName: 'Last name',
      CustomerID: 'Customer ID',
      TicketCode: 'Ticket code',
      GrandPrize: 'Grand prize',
      PrizeSet: 'Prize set',
      ErrorFetchingWinnersList: 'Error fetching winners list',
      Reversed: 'Reversed'
    },

    ConfigureRaffleCodesReview: {
      ConfigureRaffleCodes: 'Configure raffle codes',
      CodeGenerationMethod: 'Code generation method',
      TicketCodePrefix: 'Ticket code prefix',
      LengthOfCode: 'Length of code',
      TotalPermutations: 'Total permutations',
      VoucherCodeFormat: 'Voucher code format',
      VoucherCodeLength: 'Voucher code length',
      NumberOfTickets: 'Number of tickets',
      CodeFormat: 'Code format'
    },

    RewardAddedTable: {
      Order: 'Order',
      Probability: 'Probability',
      Name: 'Name',
      Value: 'Value',
      Operators: 'Operators',
      RuleName: 'Rule Name',
      NoOutcome: 'No outcome',
      AwardPoints: 'Award points',
      Merchant: 'Merchant',
      ID: 'ID',
      SellingFrom: 'Selling from',
      SellingTo: 'Selling to',
      RewardBalance: 'Reward balance',
      PointsAwarded: 'Points awarded',
      ReferrerLimits: 'Referrer limits',
      RefferalsNeeded: 'Refferals needed',
      ReffererRewardLimit: 'Referee reward limit',
      RefereeLimits: 'Referee limits',
      GLACNo: 'GL A/C No',
      GLACName: 'GL A/C Name',
      CostCenterID: 'Cost Center ID',
      BranchCode: 'Branch Code',
      GLAccountDetail: 'GL Account Detail'
    },

    QuizQuestionsReview: {
      Questions: 'Questions',
      Type: 'Type',
      TextQuestion: 'Text question',
      ImageQuestion: 'Image question',
      WrittenResponse: 'Written response',
      MultipleAnswers: 'Multiple answers',
      SingleAnswer: 'Single answer',
      Question: 'Question',
      Required: 'Required',
      Yes: 'Yes',
      No: 'No'
    },

    QuestRuleTable: {
      ID: 'ID',
      Name: 'Name',
      Status: 'Status',
      Action: 'Action',
      Edit: 'Edit',
      Remove: 'Remove'
    },

    BulkActionModal: {
      FileUploadedIsSubmittedForApproval: 'File uploaded is submitted for approval',
      FileUploaded: 'File uploaded',
      ErrorUploadingFile: 'Error uploading file.',
      Cancel: 'Cancel',
      Upload: 'Upload',
      BulkUpload: 'Bulk Upload',
      ChooseOne: 'Choose one...',
      Campaign: 'Campaign',
      PleaseSelectACampaign: 'Please select a campaign',
      LoyaltyProgram: 'Loyalty program',
      PleaseSelectALoyaltyProgram: 'Please select a loyalty program',
      ClickOrDragFileToThisAreaToUpload: 'Click or drag file to this area to upload',
      DownloadSample: 'Download Sample',
      ActionType: 'Action type',
      AcceptedFormatXlsxOrCsvFilesOnly: 'Accepted Format: .xlsx or .csv files only',
      AcceptedFormatTxtXlsxOrCsvFilesOnly: 'Accepted Format: .txt, .xlsx or .csv files only'
    }
  }
};
